// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../icons/fonts/accessgov.woff?v=7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../icons/fonts/accessgov.ttf?v=7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../icons/fonts/accessgov.svg?v=7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/search.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___, { hash: "#accessgov" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! CSS Used fontfaces */
@font-face {
  font-family: "accessgov";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/*! CSS Used from: ../bootstrap/bootstrap.css?v=-2013962739 */
:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #007bff;
  --secondary: #6c757d;
  --success: #28a745;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
nav {
  display: block;
}
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
}
hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
h2,
h3 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}
p {
  margin-top: 0;
  margin-bottom: 1rem;
}
ul {
  margin-top: 0;
  margin-bottom: 1rem;
}
ul ul {
  margin-bottom: 0;
}
small {
  font-size: 80%;
}
a {
  color: #466db2;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: #0056b3;
  text-decoration: underline;
}
a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):focus {
  outline: 0;
}
img {
  vertical-align: middle;
  border-style: none;
}
table {
  border-collapse: collapse;
}
label {
  display: inline-block;
  margin-bottom: 0.5rem;
}
button {
  border-radius: 0;
}
button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}
input,
button {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
button,
input {
  overflow: visible;
}
button {
  text-transform: none;
}
button,
[type="button"] {
  -webkit-appearance: button;
}
button::-moz-focus-inner,
[type="button"]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}
[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none;
}
h2,
h3 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}
h2 {
  font-size: 2rem;
}
h3 {
  font-size: 1.75rem;
}
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
small {
  font-size: 80%;
  font-weight: 400;
}
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.form-control::-webkit-input-placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control::-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
.form-group {
  margin-bottom: 1rem;
}
.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}
.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-label {
  margin-bottom: 0;
}
.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #212529;
  text-decoration: none;
}
.btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.btn:disabled {
  opacity: 0.65;
}
.btn-link {
  font-weight: 400;
  color: #466db2;
  text-decoration: none;
}
.btn-link:hover {
  color: #0056b3;
  text-decoration: underline;
}
.btn-link:focus {
  text-decoration: underline;
  box-shadow: none;
}
.btn-link:disabled {
  color: #6c757d;
  pointer-events: none;
}
.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}
.collapse:not(.show) {
  display: none;
}
.dropdown {
  position: relative;
}
.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
.nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover,
.nav-link:focus {
  text-decoration: none;
}
.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-item {
  margin-bottom: -1px;
}
.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}
.navbar {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar > .container-fluid {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover,
.navbar-brand:focus {
  text-decoration: none;
}
.navbar-nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}
.navbar-collapse {
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-align: center;
  align-items: center;
}
.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover,
.navbar-toggler:focus {
  text-decoration: none;
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    -ms-flex-direction: row;
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container-fluid {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-collapse {
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover,
.navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
.close:hover {
  color: #000;
  text-decoration: none;
}
button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
.popover .arrow::before,
.popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}
.bs-popover-top {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow {
  bottom: calc((0.5rem + 1px) * -1);
}
.bs-popover-top > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}
.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}
.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}
.d-none {
  display: none !important;
}
.d-block {
  display: block !important;
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-block {
    display: block !important;
  }
}
.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.text-left {
  text-align: left !important;
}
.text-center {
  text-align: center !important;
}
@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
}
.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.badge-light {
  color: #212529;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}
/*! CSS Used from: ../DynamicForms/DFStyle_Master.css?v=-2013962739 */
html {
  min-height: 100%;
  position: relative;
}
.form-control {
  color: #333333;
}
.form-control::-webkit-input-placeholder {
  color: #999999;
  opacity: 1;
}
.form-control::-moz-placeholder {
  color: #999999;
  opacity: 1;
}
.form-control:-ms-input-placeholder {
  color: #999999;
  opacity: 1;
}
.form-control::-ms-input-placeholder {
  color: #999999;
  opacity: 1;
}
.form-control::placeholder {
  color: #999999;
  opacity: 1;
}
.nav.navbar-nav {
  margin: 0;
}
nav {
  display: block;
}
@media (max-width: 767px) {
  body {
    padding-bottom: 0;
  }
}
/*! CSS Used from: ../icons/style.css?v=7 */
.icon:before {
  font-family: accessgov !important;
  speak: never;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-info:before {
  content: "\\62";
}
.icon-search:before {
  content: "\\49";
}
.icon-close:before {
  content: "\\74";
}
.icon-user-solid:before {
  content: "\\e90d";
}
@font-face {
  font-style: normal;
  font-weight: 400;
  src: local("Open Sans Regular"), local("OpenSans-Regular"), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFUZ0bbck.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* variables for easier Custom Less modification */
html {
  position: relative;
  min-height: 100vh;
}
body {
  padding-top: 70px;
  background: #fff;
  background-size: cover;
  font-weight: normal;
  font-family: "Open Sans", sans-serif;
}
.body-content {
  width: 100%;
  position: relative;
}
a {
  color: #466db2;
}
a:hover {
  cursor: pointer;
  color: #304b7b;
}
p {
  clear: none;
}
h1 {
  line-height: 1;
  color: #333;
}
h1,
h2,
h3 {
  margin-top: 10px;
  font-weight: 500;
}
h1 {
  font-size: 1.9rem;
}
h2 {
  font-size: 1.65rem;
}
h3 {
  font-size: 1.45rem;
}
h4 {
  font-size: 1.3rem;
}
h5 {
  font-size: 1.15rem;
}
h6 {
  font-size: 1rem;
}
.pull-right {
  float: right;
}
.loading {
  margin: 15px auto;
  display: block;
  margin: 0 auto;
  height: 100px;
}
.text-smaller {
  font-size: 0.875rem;
}
.tile {
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
}
[data-bind*="clickOrEnter"],
[data-bind^="clickOrEnter"] {
  cursor: pointer;
}
.dropdown-menu li,
.returning_user li {
  list-style-type: none;
  list-style-position: initial;
}
.previous-question {
  padding: 5px 10px;
  border-top: 1px solid #ddd;
  font-size: 13px;
  cursor: pointer;
}
.previous-question strong {
  font-size: 15px;
}
.current-question {
  border-top: 1px solid #ddd;
}
.answer.disabled {
  opacity: 0.65;
}
.previous-question:hover,
.previous-question:focus {
  background: #f5f5f5;
}
.dropdown-menu {
  border-radius: 0 0 6px 6px;
}
.dropdown.open .dropdown-menu {
  opacity: 1;
}
.dropdown-toggle.show + .dropdown-menu {
  display: block;
}
label {
  font-weight: 500;
}
#jsPageEditor .form-control,
#jsPageEditor .vs__dropdown-toggle,
#jsPageEditor .form-group .input-group .input-group-text {
  font-weight: normal;
  border-color: #787878;
}
#jsPageEditor .vs__dropdown-toggle .vs__open-indicator {
  fill: #333333;
}
#jsPageEditor .form-control:focus,
#jsPageEditor .vs--open .vs__dropdown-toggle {
  border-width: 2px;
  border-color: rgba(0, 0, 0, 0.87);
  box-shadow: unset;
}
#jsPageEditor .form-control:focus ~ .vs__dropdown-menu,
#jsPageEditor .vs--open .vs__dropdown-toggle ~ .vs__dropdown-menu {
  --vs-border-width: 0;
}
#jsPageEditor .form-group .btn-group {
  border-radius: 0.35rem;
}
#jsPageEditor .form-group.text-form-group .input-group-append .input-group-text:focus,
#jsPageEditor .form-group.text-form-group .input-group-prepend .input-group-text:focus {
  z-index: 0;
}
#jsPageEditor .form-group.has-custom-errors .border-mixin {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
}
#jsPageEditor .form-group.has-custom-errors .border-focus-mixin {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors .invalid-border-mixin {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
}
#jsPageEditor .form-group.has-custom-errors .invalid-border-mixin:focus {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .form-control,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .form-control,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-text {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .form-control:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .form-control:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-text:focus {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text:focus {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text:focus {
  outline: 2px solid #b00020;
  box-shadow: unset;
  border: unset;
  z-index: 0;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append:not(.input-group-prepend) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append:not(.input-group-prepend) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend:not(.input-group-prepend) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend:not(.input-group-prepend) .input-group-text {
  border-left-width: 0;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append:not(.input-group-append) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append:not(.input-group-append) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend:not(.input-group-append) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend:not(.input-group-append) .input-group-text {
  border-right-width: 0;
}
#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > select.form-control,
#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > .v-select .vs__dropdown-toggle {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
}
#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > .v-select.vs--open .vs__dropdown-toggle {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-file,
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
  border-width: 2px;
}
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-file:focus,
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group:focus {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group {
  border-style: solid;
}
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group a.btn {
  border-width: 0;
}
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group .input-group-append {
  border-top-width: 0;
  border-right-width: 0;
  border-bottom-width: 0;
}
.form-check-label,
.radio-inline,
.checkbox label {
  font-weight: normal;
  margin-bottom: 0;
}
.page-loading {
  position: fixed;
  opacity: 1;
  transition: all 0.4s ease-in;
}
html.no-js .page-loading {
  display: none;
}
.page-loaded {
  opacity: 0;
  height: 0;
  transition: none;
  /*ensure wheel doesn't fade out, rather disappears*/
  z-index: -1;
}
.body-loading {
  width: 100px;
  height: 100px;
  border-radius: 1.5ex;
  padding: 0.2ex;
  position: fixed;
  left: calc(50% - 50px);
  top: calc(50% - 50px);
}
.body-loading .loading {
  height: 100%;
}
.popover-header {
  margin: 0;
}
.popper {
  background: #ffffff;
  max-width: 300px;
  border: 1px solid #cccccc;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  padding: 7.5px;
}
.form-check.answer {
  position: static;
}
.v--modal-overlay {
  z-index: 1002;
}
.modal-content {
  border: none;
  max-height: 100vh;
  overflow-y: auto;
}
/* ------------------------
 NAVIGATION
-/----------------------- */
.skip-navigation-link:focus {
  display: block;
  top: 0;
  width: auto !important;
  height: auto !important;
  z-index: 998999;
  background: white;
  clip: unset;
}
.navbar-dark {
  background-color: #2b2b2b;
  /*min-height: 60px;*/
  padding-top: 5px;
  padding-bottom: 5px;
}
.navbar-dark {
  padding-left: 0;
  padding-right: 0;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
}
.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: #ffffff;
}
.navbar-dark .nav-link:focus,
.navbar-dark .nav-link:focus-visible {
  outline: 2px solid #fff;
  outline-offset: -2px;
  box-shadow: none;
}
.navbar-dark a {
  white-space: nowrap;
}
.navbar-dark a:hover,
.navbar-dark a:focus {
  text-decoration: none;
}
.icon-bar {
  display: block;
  background: #ffffff;
  height: 1px;
  width: 18px;
  margin-top: 5px;
}
.navbar-fixed-top .navbar-collapse,
.navbar-fixed-bottom .navbar-collapse {
  max-height: none;
  border: none;
  box-shadow: none;
  padding: 0;
  width: 100%;
}
.navbar-dark .navbar-nav > li > a {
  color: #fff;
  font-size: 15px;
  text-decoration: none;
  display: inline-block;
  letter-spacing: 0.5px;
  /*text-transform: uppercase;*/
}
.navbar-dark .navbar-nav > li {
  padding: 13px 7.5px;
}
.navbar-dark .navbar-nav > li button {
  margin-bottom: 0;
}
.navbar-dark .navbar-nav > li ::-webkit-input-placeholder,
.navbar-dark .navbar-nav > li :-moz-placeholder,
.navbar-dark .navbar-nav > li ::-moz-placeholder,
.navbar-dark .navbar-nav > li :-ms-input-placeholder {
  color: #fff !important;
  opacity: 1 !important;
}
fieldset {
  border: none;
  padding: 0;
  margin: 0;
}
legend {
  font-size: 1.2em;
  font-weight: 500;
}
.navbar-dark .navbar-nav > .vr {
  height: 50px;
  width: 1px;
  margin-top: 5px;
  margin-left: 7px;
  padding-left: 0;
  padding-right: 7px;
  border-left: 1px solid #3e3e3e;
}
.navbar-dark .navbar-nav > li:not(.active) > a:hover,
.navbar-dark .navbar-nav > li > a:focus,
.navbar-dark .navbar-nav > li:focus,
.navbar-dark .navbar-nav > li.open > a:hover,
.navbar-dark .navbar-nav > li.open > a:focus,
.navbar-dark .navbar-nav > li.open > a:active,
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus,
.dropdown-menu > li > a:active {
  color: #fff;
  background: #2b2b2b;
  border-color: transparent;
}
.navbar-dark .navbar-nav > .open > a:hover,
.navbar-dark .navbar-nav > .open > a:focus {
  background: #27221a;
}
.navbar-dark .navbar-brand {
  padding: 0;
  /* cspell:ignore ccess */
}
.navbar-dark .navbar-brand img {
  height: 50px;
  display: inline;
}
.navbar-dark .navbar-brand .brand-letters {
  display: inline;
  margin-left: 4px;
}
.navbar-dark .navbar-brand .brand-letters img {
  height: 25px;
}
.navbar-dark .navbar-brand .brand-letters-ccess,
.navbar-dark .navbar-brand .brand-letters-gov {
  font-size: 40px;
  letter-spacing: 6pt;
  vertical-align: middle;
  display: inline-block;
  margin-top: -1px;
}
.navbar-dark .navbar-brand .brand-letters-ccess {
  font-weight: bold;
  color: #ccc;
}
.navbar-dark .navbar-brand .brand-letters-gov {
  color: #fff;
}
.navbar-dark .navbar-right {
  font-size: 1.1em;
  letter-spacing: 0.4pt;
  margin: 0;
  margin-right: -15px;
  margin-left: auto;
}
.form-control.search-control {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center left 7.5px;
  background-size: 15px;
  padding-left: 30px;
}
.navbar-dark .form-control.search-control:focus {
  border-bottom-color: #fff;
}
.search-backdrop,
.my-forms-backdrop {
  /*display: none;*/
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 10000;
}
.search-backdrop .close {
  position: fixed;
  top: 30px;
  right: 30px;
  color: #fff;
  font-size: 2em;
  opacity: 1;
}
.search-backdrop .close img {
  height: 20px;
}
.search-backdrop .search-form-wrapper {
  width: 600px;
  height: 100px;
  max-width: 100%;
  position: fixed;
  top: 25vh;
  left: calc(50% - 300px);
}
.search-backdrop .search-form-wrapper .form-group label {
  font-size: 1.5em;
  color: #aaa;
  margin-bottom: 0;
  -webkit-transition: all 0.25s;
  transition: all 0.25s;
}
.search-backdrop .search-form-wrapper .form-group .form-control {
  background: none;
  height: 40px;
  color: #ddd;
  border: none;
  padding: 10px;
  border-bottom: 1px solid #aaa;
  border-radius: 0;
  box-shadow: none;
}
.search-backdrop .search-form-wrapper .form-group .form-control:focus {
  border-color: #466db2;
  border-bottom-width: 2px;
}
.nav-search-results {
  position: relative;
  height: auto;
  max-height: calc(75vh - 125px);
  min-height: 75px;
  overflow-y: auto;
  width: 600px;
  max-width: 100%;
  background: #fff;
  margin-top: 0;
  padding: 0;
  border-radius: 4px;
  box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.25);
  overflow: auto;
}
.nav-search-results .nav-search-results-inner {
  padding: 15px;
  position: relative;
  height: auto;
  width: 100%;
  overflow-x: hidden;
  text-align: left;
}
.nav-search-results .nav-search-results-caption {
  position: absolute;
  top: 5px;
  right: 10px;
  display: inline-block;
  color: #636363;
  font-size: 12px;
  /*font-weight: 600;*/
}
.nav-search-results .result {
  padding-top: 5px;
  letter-spacing: normal;
  /*font-size: 14px;*/
  text-align: left;
}
.nav-search-results .result:first-of-type {
  padding-top: 10px;
}
.close {
  opacity: 0.7;
  font-size: 1.25em;
}
.dropdown-menu {
  padding: 0;
  padding-bottom: 8px;
}
.dropdown-menu > li > a {
  display: block;
  color: #fff;
  font-size: 13px;
  padding: 6px 18px;
}
.dropdown-menu .divider {
  opacity: 0.3;
  background-color: #000000;
  margin: 0;
  display: none;
}
.pane-size-toggle {
  font-size: 32px;
  margin-top: -10px;
  -webkit-appearance: none;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  float: right;
}
.toolbox_pane .pane-size-toggle {
  margin-top: -14px;
}
.toggle-symbol {
  font-size: 24px;
  margin-top: -10px;
}
.toggle-smaller {
  margin-left: 7px;
}
.toggle-larger {
  margin-left: 0;
}
.pane-size-toggle.close:hover {
  opacity: 1;
}
.df-public-nav .navbar {
  min-height: 0;
}
.navbar-toggle.public_pages_toggle {
  margin: 5px;
  padding: 5px;
}
.navbar-collapse .list-group {
  margin-bottom: 0;
}
.btn .icon {
  line-height: 0;
  vertical-align: inherit;
}
.btn .icon-trash {
  font-size: 1.1em;
}
.btn .icon-undo,
.btn .icon-redo {
  font-size: 1.15em;
}
.btn-link {
  color: #466db2;
}
.btn-link.icon:active,
.btn-link.icon:focus {
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}
.btn-group-vertical .btn {
  margin-bottom: 0;
}
.fixed-top {
  z-index: 1001;
}
.btn-primary {
  background: #234d7f;
  color: #fff;
  border-color: transparent;
}
.btn-primary:hover {
  background: #3471bb;
  border-color: #3471bb;
  color: #fff;
}
.btn-primary:focus {
  outline: 2px solid #3471bb;
  outline-offset: 2px;
  box-shadow: unset;
}
.btn-primary:active {
  background: #3471bb !important;
  color: #fff !important;
  border-color: #183557;
}
.btn-outline-primary:hover {
  background: #234d7f;
  border-color: #234d7f;
}
.btn-outline-primary:focus {
  background: #234d7f;
  color: #fff;
  outline: 2px solid #234d7f;
  outline-offset: 2px;
  box-shadow: unset;
}
.btn-outline-secondary:focus {
  background: #6c757d;
  color: #ffffff;
  outline: 2px solid #6c757d;
  outline-offset: 2px;
  box-shadow: unset;
}
.btn-outline-danger:focus {
  background: #dc3545;
  color: #ffffff;
  outline: 2px solid #dc3545;
  outline-offset: 2px;
  box-shadow: unset;
}
.btn-outline-success:focus {
  background: #28a745;
  color: #ffffff;
  outline: 2px solid #28a745;
  outline-offset: 2px;
  box-shadow: unset;
}
.btn-bare:focus {
  outline: 2px solid rgba(0, 0, 0, 0.87);
  outline-offset: 2px;
  box-shadow: unset;
}
.btn-block {
  display: block;
  width: 100%;
}
.btn.btn-xs {
  padding: 2px 5px;
  font-size: 0.75rem;
  border-radius: 3px;
  -webkit-transition: 0.1s all ease-in-out;
  -moz-transition: 0.1s all ease-in-out;
  -o-transition: 0.1s all ease-in-out;
  transition: 0.1s all ease-in-out;
}
.notificationBarTop {
  background: #ffc107;
  color: #121212;
  text-align: center;
  line-height: 2.5;
  overflow: hidden;
  /*margin-top: -15px;
    margin-bottom: 15px;*/
}
.notificationBarTop a,
.notificationBarTop button:not(.close) {
  color: #121212;
  font-weight: bold;
  border-bottom: 1px solid #121212;
  border-radius: 0;
  padding: 0;
}
.notificationBarTop a:hover,
.notificationBarTop button:not(.close):hover {
  color: #0a0c0d;
}
.notificationBarTop button:not(.close) {
  text-decoration: none;
}
.notificationBarTop .close {
  color: #eeeeee;
  padding: 7px 10px;
  opacity: 0.8;
  font-size: 1.3em;
}
.notificationBarTop .close:hover {
  opacity: 1;
}
.notificationBarTop .close:not(:disabled):not(.disabled):hover,
.notificationBarTop .close:not(:disabled):not(.disabled):focus {
  color: #fff;
  opacity: 0.75;
}
.tab-content .result {
  border-bottom: 1px solid #ddd;
  padding: 15px;
}
.tab-content .result:first-of-type {
  border-top: 1px solid #ddd;
}
.form-group {
  margin-bottom: 0.75rem;
  /*label.focused {
        color: @focus;
    }*/
}
.form-group label.sr-only {
  position: absolute;
}
.form-group legend {
  font-size: 1em;
  font-weight: 600;
  border-bottom: none;
  margin-bottom: 2px;
}
.form-group .radio-inline,
.form-group .checkbox-inline,
.form-group .checkbox label,
.form-group .radio label {
  margin-left: 0;
  margin-right: 10px;
}
/*.radio-inline,
.radio,
.checkbox-inline,
.checkbox {
    font-size: 14px;
}*/
.loading {
  margin: 15px auto;
  display: block;
  margin: 0 auto;
  height: 100px;
}
.have_not_searched {
  text-align: center;
  height: 100%;
  width: 100%;
  /*padding-top: 15px;*/
}
.have_not_searched:before {
  /*content: "Use this search tool to find forms.";*/
  font-size: 1.2em;
  vertical-align: middle;
}
#questionsDiv {
  position: relative;
  margin-bottom: 20px;
}
#questionsDiv .radio {
  margin-bottom: 7px;
}
.public-page-body .body-content {
  padding: 0;
}
/* ------------------------
 AUTHENTICATED USER
------------------------ */
.index-container {
  display: flex;
  flex: 1;
  flex-direction: column-reverse;
}
.index-content legend {
  display: block;
  width: 100%;
  text-align: center;
}
.returning_user {
  overflow: auto;
  flex: 0 0 100%;
  padding: 0px 15px 15px 15px;
  background: #f9f9f9;
  border-top: 1px solid #ccc;
}
.returning_user .returning_user_header,
.returning_user .returning_user_body {
  visibility: visible;
}
.returning_user .nav-tabs {
  border-bottom-color: #bbbbbb;
}
.returning_user .nav-tabs li button {
  background: none !important;
}
.returning_user .badge {
  margin-left: 5px;
}
.returning_user .tab-content {
  padding: 4px 0;
  border: none;
  border-top: none;
}
.returning_user .returning_user_list_of_forms {
  list-style: none;
  padding: 0;
}
.returning_user .returning_user_list_of_forms li {
  position: relative;
  display: table;
  width: 100%;
  padding: 0.5rem;
  border-bottom: 1px solid #ccc;
}
.returning_user .returning_user_list_of_forms li .returning_user_actions {
  float: right;
  display: block;
}
#MyFormsHeading {
  margin-top: 15px;
  margin-bottom: 10px;
}
.submitted_timestamp {
  font-size: 12px;
  color: #6d6d6d;
  float: left;
  margin-top: 5px;
}
.my-forms-tag {
  display: block;
  clear: both;
  padding: 2px 6px;
  border-radius: 100px;
  font-size: 80%;
  margin-top: 5px;
  margin-bottom: 2.5px;
  float: left;
}
.my-forms-tag.returned {
  background: #ffebce;
}
.my-forms-tag.in-progress {
  background: #e0edff;
}
.my-forms-tag.done {
  background: #dbf2e4;
}
.my-forms-tag.unavailable {
  background: #ffe0e0;
}
.badge {
  font-weight: 600;
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.badge-primary {
  color: #fff;
  background-color: #007bff;
}
.badge-light {
  border: 1px solid #dee2e6;
}
div .nav-tabs {
  margin-right: 0;
}
.nav-tabs > li > .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
}
.nav-tabs > li > .nav-link.active,
.nav-tabs > li > .nav-link.active:hover,
.nav-tabs > li > .nav-link.active:focus {
  border-bottom: 3px solid #466db2;
  background-color: #fff;
  border-radius: 0;
  color: #466db2 !important;
  border-bottom-color: #466db2 !important;
}
/*.nav-tabs > li.active > .nav-link.show {
    border-bottom-color: transparent;
}

.nav-tabs > li.active > .nav-link,
.nav-tabs > li.active > .nav-link:hover,
.nav-tabs > li.active > .nav-link:focus {
    border-bottom: 3px solid @focus;
    background-color: #fff;
    border-radius: 0;
    color: @focus !important;
    border-bottom-color: @focus !important;

    .badge {
        background-color: #333;
    }
}*/
.nav-tabs > li {
  margin-bottom: -1px;
}
.nav-tabs > li > .nav-link,
.nav-tabs > li > .nav-link:hover {
  color: inherit;
  margin-right: 0;
  background-color: transparent;
}
#myFormsDiv {
  max-height: 495px;
  overflow: auto;
}
#myFormsDiv ul {
  padding-left: 20px;
}
#myFormsDiv li {
  margin-bottom: 10px;
}
.navbar-dark .navbar-nav > li.login > a img,
.navbar-dark .navbar-nav > li.login.dropdown > a img {
  height: 20px;
  margin-right: 5px;
}
.navbar-dark .navbar-nav > li > a,
.navbar-dark .navbar-nav > li > a:hover,
.navbar-dark .navbar-nav > li > a:focus {
  color: #fff;
  background: transparent;
}
.navbar-dark .navbar-nav > li .dropdown-menu {
  background-color: #2b2b2b;
  border: 0;
  left: auto;
  right: 0;
}
.navbar-dark .navbar-nav > li .dropdown-menu > li > a,
.navbar-dark .navbar-nav > li .dropdown-menu > li {
  color: #fff;
  /*text-transform: uppercase;*/
}
.nav .open > a,
.nav .open > a:hover,
.nav .open > a:focus {
  border-color: transparent;
}
.help-block {
  color: #717171;
  font-size: 13px;
}
/*----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/* ------------------------
 FOOTER
------------------------ */
#demo {
  width: 600px;
  padding-top: 5px;
  margin-left: 10px;
  float: left;
}
#demo a,
a.visited,
a.hover {
  text-decoration: none;
  border: none;
}
#footer {
  background: #2b2b2b;
  color: rgba(255, 255, 255, 0.9);
  width: 100%;
}
#footer ul {
  padding: 24px 20px;
  list-style-type: none;
  text-align: center;
  list-style: none outside none;
  z-index: 11;
  bottom: 0px;
  margin: 0px auto;
  flex: auto;
  display: inline;
}
#footer ul li {
  margin: 0 5px;
  display: inline-block;
  color: #e2d5b4;
}
#footer ul li a {
  background: none;
  color: #fff;
  letter-spacing: normal;
  font-size: 12px;
}
#footer ul li:first-of-type {
  margin-left: 0;
}
#footer ul li:last-of-type {
  margin-right: 0;
}
#footer ul li:hover {
  background: none;
  color: #e2d5b4;
}
#footer > a {
  margin-left: auto;
  max-height: 48px;
  border: none;
}
.mi-footer-logo {
  height: 35px;
  margin-top: -6px;
}
.accessgov-footer-logo {
  height: 45px;
  margin-top: -10px;
}
.visible-xs-inline-block {
  display: none;
}
.my-forms-backdrop {
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  width: 100%;
  z-index: 999;
}
.index-logo {
  height: 150px;
  margin: 10px auto;
  max-width: 100%;
}
.public-page-body .tile {
  margin-top: 20px;
  margin-bottom: 20px;
}
.public-page-body .body-content {
  padding: 0 5px;
}
@media (max-width: 767px) {
  body {
    padding-top: 60px;
    background-image: none;
    padding-bottom: 0 !important;
  }
  .body-content {
    margin-top: 0;
    padding-top: 0;
  }
  .transitions-after-load .body-content {
    height: 100vh;
  }
  .nav .dropdown {
    position: static;
  }
  .dropdown-menu {
    position: static;
    box-shadow: none;
  }
  .notificationBarTop {
    /*margin-top: -10px;*/
    margin-bottom: 0;
  }
  #footer {
    position: static;
    text-align: center;
    height: auto;
    /*margin-top: 25px;*/
    padding: 15px 0;
    display: block;
  }
  #footer ul {
    display: block;
    width: 90%;
  }
  #footer ul li {
    display: block;
    margin-left: 0;
    margin-right: 0;
  }
  #footer ul li a:link,
  #footer ul li a {
    /*background: @primary-light;*/
    float: none;
    margin: 0.5em 0px;
    padding: 1.2em 0 1.2em;
    height: auto;
    display: block;
    margin-bottom: 5px;
    /*color: #fff;*/
    padding-top: 10px;
    padding-bottom: 10px;
  }
  #footer ul li a:link:hover,
  #footer ul li a:hover {
    background: #eee !important;
    text-decoration: underline;
    color: #2b2b2b;
  }
  #footer ul li:hover a {
    background: #454545;
  }
  #questionsDiv {
    height: auto;
    padding-bottom: 0;
    position: relative;
  }
  .form-control {
    max-width: none;
  }
  .visible-xs-inline-block {
    display: inline-block !important;
  }
  .have_not_searched {
    background-position: center center;
    background-size: 150px;
    padding-top: 30px;
  }
  /*.dfNavButton:not(.dfNavRemoveButton) {
        display: block;
        width: 100%;
        margin-bottom: 5px;
    }*/
  .dropdown-toggle {
    width: 100%;
  }
  .pane-size-toggle {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    margin-top: -8px !important;
    margin-right: 0 !important;
  }
  .navbar-dark {
    padding: 13px 5px;
  }
  .navbar-dark a.search-toggle,
  .navbar-dark a.search-toggle:hover,
  .navbar-dark a.search-toggle:focus {
    float: right;
    color: #ffffff;
    opacity: 0.8;
    padding: 0 10px;
  }
  .navbar-dark a.search-toggle .icon,
  .navbar-dark a.search-toggle:hover .icon,
  .navbar-dark a.search-toggle:focus .icon {
    display: block;
    margin-top: 2px;
  }
  .navbar-dark .navbar-brand {
    width: min-content;
    margin: 0 auto;
  }
  .navbar-dark .navbar-brand img {
    height: 33px;
  }
  .navbar-dark .navbar-brand .brand-letters {
    margin-left: 3px;
  }
  .navbar-dark .navbar-brand .brand-letters img {
    height: 15px;
  }
  .navbar-dark .navbar-toggler,
  .navbar-dark .navbar-toggler:focus,
  .navbar-dark .navbar-toggler:hover {
    background: #2b2b2b;
    border: none;
    box-shadow: none;
    padding: 0.25rem 0.75rem 0.5rem 0.75rem;
    /*.navbar-toggler-icon {
                width: 20px;
                height: 20px;
            }*/
  }
  .search-backdrop,
  .my-forms-backdrop {
    padding: 5px 15px;
    height: 150vh;
  }
  .search-backdrop .close {
    font-size: 1.4em;
    top: 15px;
    right: 15px;
  }
  .search-backdrop .close img {
    height: 15px;
  }
  .search-backdrop .search-form-wrapper {
    position: static;
    margin-top: 40px;
    width: 100%;
  }
  .navbar-dark .navbar-nav > .vr {
    display: none;
  }
  .navbar-dark .form-group.search-group .search-control {
    width: 100% !important;
  }
  .navbar-dark .navbar-left {
    margin-left: 0;
    margin-right: -15px;
  }
  .navbar-dark .navbar-nav > li {
    padding: 0 7px;
  }
  .navbar-dark .icon-search {
    font-size: 1.4em;
  }
  #collapse2 {
    padding: 8px;
    overflow-x: hidden;
  }
  .nav-search-results {
    position: relative;
    width: calc(100% - 30px);
    z-index: 10000;
    max-height: calc(100vh - 150px);
    /*background: #fff;
        margin-top: 0;
        padding: 0;
        border: 1px solid #ddd;
        box-shadow: 0 2px 6px 1px rgba(0,0,0,.25);
        overflow: auto;*/
  }
  .nav-search-results .nav-search-results-inner {
    padding: 15px;
    position: relative;
    height: auto;
    width: 100%;
  }
  .nav-search-results .nav-search-results-caption {
    position: absolute;
    top: 5px;
    right: 10px;
    display: inline-block;
    color: #717171;
    font-size: 11px;
  }
  .nav-search-results .result {
    padding-top: 5px;
    letter-spacing: normal;
    font-size: 13px;
  }
  .nav-search-results .result:first-of-type {
    padding-top: 10px;
  }
}
@media (min-width: 768px) {
  body,
  label,
  .btn,
  .form-control {
    font-size: 15px;
  }
  .navbar-dark {
    height: 70px;
  }
  .navbar-dark .navbar-brand {
    pointer-events: none;
  }
  .public-page-body .body-content {
    padding: 0;
  }
  .index-content {
    padding: 15px;
  }
  .returning_user {
    margin: 0;
  }
  .mi-footer-logo {
    float: right;
  }
  .lead {
    font-size: 16px;
  }
  .accessgov-footer-logo {
    float: left;
  }
  .my-forms-backdrop {
    display: none;
  }
  #collapse2 {
    margin-right: 10px;
  }
  .navbar-inverse .navbar-nav > li .dropdown-menu {
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  }
}
@media (max-width: 991px) {
  .img-responsive {
    /* account for large homepage images to be responsive on mobile devices */
    max-width: 100%;
    height: auto !important;
  }
}
/* Medium devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .lead {
    font-size: 17px;
  }
  .index-container {
    flex-direction: row;
    min-height: calc(100vh - 70px);
  }
  .index-container .index-content {
    flex: 1;
  }
  .index-container .returning_user {
    flex: 0 0 375px;
    border-top: none;
    border-right: 1px solid #ccc;
    overflow: auto;
  }
  .body-content {
    min-height: calc(100vh - 70px);
  }
}
@media (min-width: 1200px) {
  .have_not_searched {
    background-position: center 40%;
  }
}
@media print {
  .no_print,
  #footer,
  .btn {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./styles/DFStyle_SiteIndex_Template.less","webpack://./styles/index.css","webpack://./styles/SiteIndex.less"],"names":[],"mappings":"AAAA,wBAAwB;ACCxB;EACI,wBAAA;EACA,8KAAA;EAIA,mBAAA;EACA,kBAAA;ADFJ;AACA,6DAA6D;ACI7D;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+MAAA;EACA,6GAAA;ADFJ;ACIA;;;EAGI,sBAAA;ADFJ;ACIA;EACI,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;ADFJ;ACIA;EACI,cAAA;ADFJ;ACIA;EACI,SAAA;EACA,kMAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;ADFJ;ACIA;EACI,uBAAA;EACA,SAAA;EACA,iBAAA;ADFJ;ACIA;;EAEI,aAAA;EACA,qBAAA;ADFJ;ACIA;EACI,aAAA;EACA,mBAAA;ADFJ;ACIA;EACI,aAAA;EACA,mBAAA;ADFJ;ACIA;EACI,gBAAA;ADFJ;ACIA;EACI,cAAA;ADFJ;ACIA;EACI,cAAA;EACA,qBAAA;EACA,6BAAA;ADFJ;ACIA;EACI,cAAA;EACA,0BAAA;ADFJ;ACIA;EACI,cAAA;EACA,qBAAA;ADFJ;ACIA;;EAEI,cAAA;EACA,qBAAA;ADFJ;ACIA;EACI,UAAA;ADFJ;ACIA;EACI,sBAAA;EACA,kBAAA;ADFJ;ACIA;EACI,yBAAA;ADFJ;ACIA;EACI,qBAAA;EACA,qBAAA;ADFJ;ACIA;EACI,gBAAA;ADFJ;ACIA;EACI,mBAAA;EACA,0CAAA;ADFJ;ACIA;;EAEI,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;ADFJ;ACIA;;EAEI,iBAAA;ADFJ;ACIA;EACI,oBAAA;ADFJ;ACIA;;EAEI,0BAAA;ADFJ;ACIA;;EAEI,UAAA;EACA,kBAAA;ADFJ;ACIA;EACI,sBAAA;EACA,UAAA;ADFJ;ACIA;EACI,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ADFJ;ACIA;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;ADFJ;ACIA;EACI,oBAAA;EACA,wBAAA;ADFJ;ACIA;;EAEI,qBAAA;EACA,gBAAA;EACA,gBAAA;ADFJ;ACIA;EACI,eAAA;ADFJ;ACIA;EACI,kBAAA;ADFJ;ACIA;EACI,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,wCAAA;ADFJ;ACIA;EACI,cAAA;EACA,gBAAA;ADFJ;ACIA;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;ADFJ;ACIA;EACI;IACI,gBAAA;EDFN;AACF;ACIA;EACI;IACI,gBAAA;EDFN;AACF;ACIA;EACI;IACI,gBAAA;EDFN;AACF;ACIA;EACI;IACI,iBAAA;EDFN;AACF;ACIA;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;ADFJ;ACIA;EACI,cAAA;EACA,WAAA;EACA,mCAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,wEAAA;ADFJ;ACMA;EACI;IACI,gBAAA;EDJN;AACF;ACMA;EACI,6BAAA;EACA,SAAA;ADJJ;ACMA;EACI,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,gDAAA;ADJJ;ACMA;EACI,cAAA;EACA,UAAA;ADJJ;ACMA;EACI,cAAA;EACA,UAAA;ADJJ;ACMA;EACI,cAAA;EACA,UAAA;ADJJ;ACMA;EACI,cAAA;EACA,UAAA;ADJJ;ACMA;EACI,cAAA;EACA,UAAA;ADJJ;ACMA;EACI,yBAAA;EACA,UAAA;ADJJ;ACMA;EACI,mBAAA;ADJJ;ACMA;EACI,kBAAA;EACA,cAAA;EACA,qBAAA;ADJJ;ACMA;EACI,kBAAA;EACA,kBAAA;EACA,qBAAA;ADJJ;ACMA;EACI,gBAAA;ADJJ;ACMA;EACI,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,qIAAA;ADJJ;ACUA;EACI;IACI,gBAAA;EDRN;AACF;ACUA;EACI,cAAA;EACA,qBAAA;ADRJ;ACUA;EACI,UAAA;EACA,gDAAA;ADRJ;ACUA;EACI,aAAA;ADRJ;ACUA;EACI,gBAAA;EACA,cAAA;EACA,qBAAA;ADRJ;ACUA;EACI,cAAA;EACA,0BAAA;ADRJ;ACUA;EACI,0BAAA;EACA,gBAAA;ADRJ;ACUA;EACI,cAAA;EACA,oBAAA;ADRJ;ACUA;EACI,gCAAA;ADRJ;ACUA;EACI;IACI,gBAAA;EDRN;AACF;ACUA;EACI,UAAA;ADRJ;ACUA;EACI,aAAA;ADRJ;ACUA;EACI,kBAAA;ADRJ;ACUA;EACI,mBAAA;ADRJ;ACUA;EACI,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ADRJ;ACUA;EACI,cAAA;ADRJ;ACUA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,qCAAA;EACA,sBAAA;ADRJ;ACUA;EACI,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ADRJ;ACUA;EACI,cAAA;EACA,oBAAA;ADRJ;ACUA;;EAEI,qBAAA;ADRJ;ACUA;EACI,gCAAA;ADRJ;ACUA;EACI,mBAAA;ADRJ;ACUA;EACI,6BAAA;EACA,+BAAA;EACA,gCAAA;ADRJ;ACUA;;EAEI,qCAAA;ADRJ;ACUA;EACI,cAAA;EACA,sBAAA;EACA,kCAAA;ADRJ;ACUA;EACI,aAAA;ADRJ;ACUA;EACI,cAAA;ADRJ;ACUA;EACI,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;ADRJ;ACUA;EACI,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,8BAAA;ADRJ;ACUA;EACI,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;ADRJ;ACUA;;EAEI,qBAAA;ADRJ;ACUA;EACI,oBAAA;EACA,aAAA;EACA,0BAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ADRJ;ACUA;EACI,gBAAA;EACA,eAAA;ADRJ;ACUA;EACI,gBAAA;EACA,WAAA;ADRJ;ACUA;EACI,6BAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;ADRJ;ACUA;EACI,wBAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,sBAAA;ADRJ;ACUA;;EAEI,qBAAA;ADRJ;ACUA;EACI;IACI,gBAAA;IACA,eAAA;EDRN;AACF;ACUA;EACI;IACI,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,2BAAA;EDRN;ECUE;IACI,uBAAA;IACA,mBAAA;EDRN;ECUE;IACI,kBAAA;EDRN;ECUE;IACI,qBAAA;IACA,oBAAA;EDRN;ECUE;IACI,qBAAA;IACA,iBAAA;EDRN;ECUE;IACI,+BAAA;IACA,wBAAA;IACA,6BAAA;IACA,gBAAA;EDRN;ECUE;IACI,aAAA;EDRN;AACF;ACUA;EACI,WAAA;ADRJ;ACUA;;EAEI,WAAA;ADRJ;ACUA;EACI,+BAAA;ADRJ;ACUA;;EAEI,gCAAA;ADRJ;ACUA;EACI,+BAAA;EACA,sCAAA;ADRJ;ACUA;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;ADRJ;ACUA;EACI,WAAA;EACA,qBAAA;ADRJ;ACUA;EACI,UAAA;EACA,6BAAA;EACA,SAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;ADRJ;ACUA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,kMAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,4BAAA;EACA,oCAAA;EACA,qBAAA;ADRJ;ACUA;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;ADRJ;ACUA;;EAEI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ADRJ;ACUA;EACI,qBAAA;ADRJ;ACUA;EACI,iCAAA;ADRJ;ACUA;EACI,SAAA;EACA,6BAAA;EACA,qCAAA;ADRJ;ACUA;EACI,WAAA;EACA,6BAAA;EACA,sBAAA;ADRJ;ACUA;EACI,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gCAAA;EACA,0CAAA;EACA,2CAAA;ADRJ;ACUA;EACI,aAAA;ADRJ;ACUA;EACI,uBAAA;EACA,cAAA;ADRJ;ACUA;EACI,wBAAA;ADRJ;ACUA;EACI,yBAAA;ADRJ;ACUA;EACI;IACI,wBAAA;EDRN;ECUE;IACI,yBAAA;EDRN;AACF;ACUA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;ADRJ;ACUA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ADRJ;ACUA;EACI,2BAAA;ADRJ;ACUA;EACI,6BAAA;ADRJ;ACUA;EACI;;;IAGI,4BAAA;IACA,2BAAA;EDRN;ECUE;IACI,0BAAA;EDRN;ECUE;;IAEI,wBAAA;EDRN;ECUE;;;IAGI,UAAA;IACA,SAAA;EDRN;ECUE;;IAEI,uBAAA;EDRN;ECUE;IACI,2BAAA;EDRN;ECUE;IACI,2BAAA;EDRN;ECUE;IACI,aAAA;EDRN;AACF;ACUA;EACI,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qIAAA;ADRJ;ACcA;EACI,cAAA;EACA,yBAAA;EACA,yBAAA;ADZJ;AACA,qEAAqE;ACcrE;EACI,gBAAA;EACA,kBAAA;ADZJ;ACcA;EACI,cAAA;ADZJ;ACcA;EACI,cAAA;EACA,UAAA;ADZJ;ACcA;EACI,cAAA;EACA,UAAA;ADZJ;ACcA;EACI,cAAA;EACA,UAAA;ADZJ;ACcA;EACI,cAAA;EACA,UAAA;ADZJ;ACcA;EACI,cAAA;EACA,UAAA;ADZJ;ACcA;EACI,SAAA;ADZJ;ACcA;EACI,cAAA;ADZJ;ACcA;EACI;IACI,iBAAA;EDZN;AACF;AACA,2CAA2C;ACc3C;EACI,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;ADZJ;ACcA;EACI,cAAA;ADZJ;ACcA;EACI,cAAA;ADZJ;ACcA;EACI,cAAA;ADZJ;ACcA;EACI,gBAAA;ADZJ;AEpzBA;EACI,kBAAA;EACA,gBAAA;EACA,2JAAA;EAIA,4DAAA;AFmzBJ;AACA,kDAAkD;AE9yBlD;EACI,kBAAA;EACA,iBAAA;AFgzBJ;AE7yBA;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;AF+yBJ;AE5yBA;EACI,WAAA;EACA,kBAAA;AF8yBJ;AE3yBA;EACI,cAAA;AF6yBJ;AE1yBA;EACI,eAAA;EACA,cAAA;AF4yBJ;AEzyBA;EACI,WAAA;AF2yBJ;AExyBA;EACI,cAAA;EACA,WAAA;AF0yBJ;AEvyBA;;;EAGI,gBAAA;EACA,gBAAA;AFyyBJ;AEtyBA;EACI,iBAAA;AFwyBJ;AEryBA;EACI,kBAAA;AFuyBJ;AEpyBA;EACI,kBAAA;AFsyBJ;AEnyBA;EACI,iBAAA;AFqyBJ;AElyBA;EACI,kBAAA;AFoyBJ;AEjyBA;EACI,eAAA;AFmyBJ;AEhyBA;EACI,YAAA;AFkyBJ;AE/xBA;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;AFiyBJ;AE9xBA;EACI,mBAAA;AFgyBJ;AE7xBA;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;AF+xBJ;AE5xBA;;EAEI,eAAA;AF8xBJ;AE3xBA;;EAEI,qBAAA;EACA,4BAAA;AF6xBJ;AE1xBA;EACI,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;AF4xBJ;AEhyBA;EAOQ,eAAA;AF4xBR;AExxBA;EACI,0BAAA;AF0xBJ;AEvxBA;EACI,aAAA;AFyxBJ;AEtxBA;;EAEI,mBAAA;AFwxBJ;AErxBA;EACI,0BAAA;AFuxBJ;AEpxBA;EAEQ,UAAA;AFqxBR;AEhxBI;EACI,cAAA;AFkxBR;AE9wBA;EACI,gBAAA;AFgxBJ;AE3wBA;;;EAIQ,mBAAA;EACA,qBAAA;AF4wBR;AEjxBA;EASQ,aAAA;AF2wBR;AEpxBA;;EAcQ,iBAAA;EACA,iCAAA;EACA,iBAAA;AF0wBR;AExwBQ;;EACI,oBAAA;AF2wBZ;AE9xBA;EAyBY,sBAAA;AFwwBZ;AEjwBoB;;EACI,UAAA;AFowBxB;AE9vBQ;EAIQ,qBAAA;EACA,iBAAA;EACA,cAAA;AF6vBhB;AEnwBQ;EASQ,iBAAA;EACA,iBAAA;AF6vBhB;AEvwBQ;EAIQ,qBAAA;EACA,iBAAA;EACA,cAAA;AFswBhB;AE9vBgB;EALA,iBAAA;EACA,iBAAA;AFswBhB;AE1vBoB;;;;EAlBJ,qBAAA;EACA,iBAAA;EACA,cAAA;AFkxBhB;AE1wBgB;;;;EALA,iBAAA;EACA,iBAAA;AFqxBhB;AErwBoB;;;;EAtBJ,qBAAA;EACA,iBAAA;EACA,cAAA;AFiyBhB;AEzxBgB;;;;EALA,iBAAA;EACA,iBAAA;AFoyBhB;AEhxB4B;;;;EACI,0BAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;AFqxBhC;AElxBwB;;;;EACI,oBAAA;AFuxB5B;AErxBwB;;;;EACI,qBAAA;AF0xB5B;AEnxBoB;;EA5CJ,qBAAA;EACA,iBAAA;EACA,cAAA;AFm0BhB;AErxBoB;EA3CJ,iBAAA;EACA,iBAAA;AFm0BhB;AElxBoB;;EAvDJ,qBAAA;EACA,iBAAA;EACA,cAAA;EAwDQ,iBAAA;AFsxBxB;AEt0BgB;;EALA,iBAAA;EACA,iBAAA;AF+0BhB;AEzxBoB;EACI,mBAAA;AF2xBxB;AE5xBoB;EAGQ,eAAA;AF4xB5B;AE/xBoB;EAMQ,mBAAA;EACA,qBAAA;EACA,sBAAA;AF4xB5B;AEvwBA;;;EAGI,mBAAA;EACA,gBAAA;AFywBJ;AEtwBA;EACI,eAAA;EACA,UAAA;EACA,4BAAA;AFwwBJ;AErwBA;EACI,aAAA;AFuwBJ;AEpwBA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;EFswBF,mDAAmD;EErwBjD,WAAA;AFuwBJ;AEpwBA;EACI,YAAA;EACA,aAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;AFswBJ;AE7wBA;EAUQ,YAAA;AFswBR;AElwBA;EACI,SAAA;AFowBJ;AEjwBA;EACI,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0CAAA;EACA,cAAA;AFmwBJ;AEhwBA;EACI,gBAAA;AFkwBJ;AE/vBA;EACI,aAAA;AFiwBJ;AE9vBA;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;AFgwBJ;AACA;;2BAE2B;AE7vB3B;EACI,cAAA;EACA,MAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AF+vBJ;AE5vBA;EACI,yBAAA;EF8vBF,oBAAoB;EE5vBlB,gBAAA;EACA,mBAAA;AF8vBJ;AE3vBA;EACI,eAAA;EACA,gBAAA;AF6vBJ;AE/vBA;EAKQ,+BAAA;EACA,eAAA;AF6vBR;AE3vBQ;;EAEI,cAAA;AF6vBZ;AEvwBA;;EAmBQ,uBAAA;EACA,oBAAA;EACA,gBAAA;AFwvBR;AE7wBA;EAyBQ,mBAAA;AFuvBR;AEhxBA;;EA8BQ,qBAAA;AFsvBR;AElvBA;EACI,cAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AFovBJ;AEjvBA;;EAEI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AFmvBJ;AEhvBA;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EFkvBF,6BAA6B;AAC/B;AE/uBA;EACI,mBAAA;AFivBJ;AElvBA;EAGQ,gBAAA;AFkvBR;AErvBA;;;;EAUQ,sBAAA;EACA,qBAAA;AFivBR;AE7uBA;EACI,YAAA;EACA,UAAA;EACA,SAAA;AF+uBJ;AE5uBA;EACI,gBAAA;EACA,gBAAA;AF8uBJ;AE3uBA;EACI,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;AF6uBJ;AE1uBA;;;;;;;;;EASI,WAAA;EACA,mBAAA;EACA,yBAAA;AF4uBJ;AEzuBA;;EAEI,mBAAA;AF2uBJ;AExuBA;EACI,UAAA;EF0uBF,wBAAwB;AAC1B;AE5uBA;EAGQ,YAAA;EACA,eAAA;AF4uBR;AEhvBA;EAQQ,eAAA;EACA,gBAAA;AF2uBR;AEpvBA;EAWY,YAAA;AF4uBZ;AEvvBA;;EAkBQ,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;AFyuBR;AE/vBA;EA0BQ,iBAAA;EACA,WAAA;AFwuBR;AEnwBA;EA+BQ,WAAA;AFuuBR;AEnuBA;EACI,gBAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AFquBJ;AEluBA;EACI,2FAAA;EACA,qBAAA;EACA,kBAAA;AFouBJ;AEjuBA;EACI,yBAAA;AFmuBJ;AEhuBA;;EFmuBE,iBAAiB;EEjuBf,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AFmuBJ;AE7uBA;EAYQ,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;AFouBR;AErvBA;EAmBY,YAAA;AFquBZ;AExvBA;EAwBQ,YAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;AFmuBR;AEhwBA;EAgCgB,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;AFmuBhB;AEvwBA;EAwCgB,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;AFkuBhB;AEjxBA;EAmDgB,qBAAA;EACA,wBAAA;AFiuBhB;AE3tBA;EACI,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,6CAAA;EACA,cAAA;AF6tBJ;AE1uBA;EAeQ,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AF8tBR;AElvBA;EAwBQ,kBAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EF6tBN,oBAAoB;AACtB;AE3vBA;EAkCQ,gBAAA;EACA,sBAAA;EF4tBN,mBAAmB;EE1tBb,gBAAA;AF4tBR;AEjwBA;EAyCQ,iBAAA;AF2tBR;AEvtBA;EACI,YAAA;EACA,iBAAA;AFytBJ;AEttBA;EACI,UAAA;EACA,mBAAA;AFwtBJ;AErtBA;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AFutBJ;AEptBA;EACI,YAAA;EACA,yBAAA;EACA,SAAA;EACA,aAAA;AFstBJ;AEntBA;EACI,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AFqtBJ;AEltBA;EACI,iBAAA;AFotBJ;AEjtBA;EACI,eAAA;EACA,iBAAA;AFmtBJ;AEhtBA;EACI,gBAAA;AFktBJ;AE/sBA;EACI,cAAA;AFitBJ;AE9sBA;EACI,UAAA;AFgtBJ;AE7sBA;EAEQ,aAAA;AF8sBR;AE1sBA;EACI,WAAA;EACA,YAAA;AF4sBJ;AEzsBA;EACI,gBAAA;AF2sBJ;AExsBA;EAEQ,cAAA;EACA,uBAAA;AFysBR;AE5sBA;EAMQ,gBAAA;AFysBR;AE/sBA;;EAUQ,iBAAA;AFysBR;AErsBA;EACI,cAAA;AFusBJ;AEnsBI;;EAEI,6CAAA;AFqsBR;AEjsBA;EACI,gBAAA;AFmsBJ;AEhsBA;EACI,aAAA;AFksBJ;AEzrBA;EACI,mBAAA;EACA,WAAA;EACA,yBAAA;AF2rBJ;AEzrBI;EACI,mBAAA;EACA,qBAAA;EACA,WAAA;AF2rBR;AExrBI;EAhBA,0BAAA;EACA,mBAAA;EACA,iBAAA;AF2sBJ;AEzrBI;EACI,8BAAA;EACA,sBAAA;EACA,qBAAA;AF2rBR;AEtrBI;EACI,mBAAA;EACA,qBAAA;AFwrBR;AErrBI;EACI,mBAAA;EACA,WAAA;EAnCJ,0BAAA;EACA,mBAAA;EACA,iBAAA;AF2tBJ;AEprBI;EACI,mBAAA;EACA,cAAA;EA3CJ,0BAAA;EACA,mBAAA;EACA,iBAAA;AFkuBJ;AEnrBI;EACI,mBAAA;EACA,cAAA;EAnDJ,0BAAA;EACA,mBAAA;EACA,iBAAA;AFyuBJ;AElrBI;EACI,mBAAA;EACA,cAAA;EA3DJ,0BAAA;EACA,mBAAA;EACA,iBAAA;AFgvBJ;AEjrBI;EAjEA,sCAAA;EACA,mBAAA;EACA,iBAAA;AFqvBJ;AEjrBA;EACI,cAAA;EACA,WAAA;AFmrBJ;AEhrBA;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;AFkrBJ;AE/qBA;EACI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EFirBF;yBACuB;AACzB;AExrBA;;EAWQ,cAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,UAAA;AFirBR;AE/qBQ;;EACI,cAAA;AFkrBZ;AEpsBA;EAuBQ,qBAAA;AFgrBR;AEvsBA;EA2BQ,cAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AF+qBR;AE7qBQ;EACI,UAAA;AF+qBZ;AEhtBA;;EAuCQ,WAAA;EACA,aAAA;AF6qBR;AEzqBA;EAEQ,6BAAA;EACA,aAAA;AF0qBR;AE7qBA;EAOQ,0BAAA;AFyqBR;AErqBA;EACI,sBAAA;EFuqBF;;MAEI;AACN;AExqBQ;EACI,kBAAA;AF0qBZ;AE9qBA;EASQ,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AFwqBR;AEprBA;;;;EAmBQ,cAAA;EACA,kBAAA;AFuqBR;AACA;;;;;EAKE;AE/pBF;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;AFiqBJ;AE9pBA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EFgqBF,qBAAqB;AACvB;AE7pBA;EF+pBE,kDAAkD;EE7pBhD,gBAAA;EACA,sBAAA;AF+pBJ;AE5pBA;EACI,kBAAA;EACA,mBAAA;AF8pBJ;AEhqBA;EAKQ,kBAAA;AF8pBR;AE3pBA;EAEQ,UAAA;AF4pBR;AACA;;0BAE0B;AEvpB1B;EACI,aAAA;EACA,OAAA;EACA,8BAAA;AFypBJ;AEtpBA;EAEQ,cAAA;EACA,WAAA;EACA,kBAAA;AFupBR;AEnpBA;EACI,cAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,0BAAA;AFqpBJ;AE1pBA;;EASQ,mBAAA;AFqpBR;AE9pBA;EAaQ,4BAAA;AFopBR;AEjqBA;EAiBgB,2BAAA;AFmpBhB;AEpqBA;EAuBQ,gBAAA;AFgpBR;AEvqBA;EA2BQ,cAAA;EACA,YAAA;EACA,gBAAA;AF+oBR;AE5qBA;EAiCQ,gBAAA;EACA,UAAA;AF8oBR;AEhrBA;EAqCY,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;AF8oBZ;AEvrBA;EA4CgB,YAAA;EACA,cAAA;AF8oBhB;AExoBA;EACI,gBAAA;EACA,mBAAA;AF0oBJ;AEvoBA;EACI,eAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AFyoBJ;AEtoBA;EACI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AFwoBJ;AEvoBI;EACI,mBAAA;AFyoBR;AEvoBI;EACI,mBAAA;AFyoBR;AEvoBI;EACI,mBAAA;AFyoBR;AEvoBI;EACI,mBAAA;AFyoBR;AEroBA;EACI,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qIAAA;AFuoBJ;AEhoBA;EACI,WAAA;EACA,yBAAA;AFkoBJ;AE/nBA;EACI,yBAAA;AFioBJ;AE9nBA;EACI,eAAA;AFgoBJ;AE7nBA;EACI,YAAA;EACA,oCAAA;AF+nBJ;AE5nBA;;;EAGI,gCAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uCAAA;AF8nBJ;AACA;;;;;;;;;;;;;;;;EAgBE;AE1nBF;EACI,mBAAA;AF4nBJ;AEznBA;;EAEI,cAAA;EACA,eAAA;EACA,6BAAA;AF2nBJ;AExnBA;EACI,iBAAA;EACA,cAAA;AF0nBJ;AEvnBA;EACI,kBAAA;AFynBJ;AEtnBA;EACI,mBAAA;AFwnBJ;AErnBA;;EAGQ,YAAA;EACA,iBAAA;AFsnBR;AE/mBA;;;EAGI,WAAA;EACA,uBAAA;AFinBJ;AE9mBA;EACI,yBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;AFgnBJ;AE7mBA;;EAEI,WAAA;EF+mBF,6BAA6B;AAC/B;AE5mBA;;;EAGI,yBAAA;AF8mBJ;AE3mBA;EACI,cAAA;EACA,eAAA;AF6mBJ;AACA,+NAA+N;AAC/N;;0BAE0B;AExmB1B;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AF0mBJ;AEvmBA;;;EAGI,qBAAA;EACA,YAAA;AFymBJ;AEtmBA;EACI,mBAAA;EACA,+BAAA;EACA,WAAA;AFwmBJ;AE3mBA;EAMQ,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AFwmBR;AEtnBA;EAiBY,aAAA;EACA,qBAAA;EACA,cAAA;AFwmBZ;AE3nBA;EAsBgB,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;AFwmBhB;AEjoBA;EA8BY,cAAA;AFsmBZ;AEpoBA;EAkCY,eAAA;AFqmBZ;AEvoBA;EAsCY,gBAAA;EACA,cAAA;AFomBZ;AE3oBA;EA4CQ,iBAAA;EACA,gBAAA;EACA,YAAA;AFkmBR;AE9lBA;EACI,YAAA;EACA,gBAAA;AFgmBJ;AE7lBA;EACI,YAAA;EACA,iBAAA;AF+lBJ;AE5lBA;EACI,aAAA;AF8lBJ;AE3lBA;EAEI,8BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AF4lBJ;AEzlBA;EACI,aAAA;EACA,iBAAA;EACA,eAAA;AF2lBJ;AExlBA;EACI,gBAAA;EACA,mBAAA;AF0lBJ;AEvlBA;EACI,cAAA;AFylBJ;AEllBA;EACI;IACI,iBAAA;IACA,sBAAA;IACA,4BAAA;EFolBN;EEjlBE;IACI,aAAA;IACA,cAAA;EFmlBN;EEhlBE;IAEQ,aAAA;EFilBV;EE7kBE;IACI,gBAAA;EF+kBN;EE5kBE;IACI,gBAAA;IACA,gBAAA;EF8kBN;EE3kBE;IF6kBA,qBAAqB;IE3kBjB,gBAAA;EF6kBN;EE3kBE;IACI,gBAAA;IACA,kBAAA;IACA,YAAA;IF6kBJ,oBAAoB;IE3kBhB,eAAA;IACA,cAAA;EF6kBN;EEnlBE;IASQ,cAAA;IACA,UAAA;EF6kBV;EEvlBE;IAaY,cAAA;IACA,cAAA;IACA,eAAA;EF6kBd;EE5lBE;;IF+lBA,8BAA8B;IE3kBd,WAAA;IAEA,iBAAA;IACA,sBAAA;IACA,YAAA;IACA,cAAA;IACA,kBAAA;IF4kBhB,eAAe;IE1kBC,iBAAA;IACA,oBAAA;EF4kBlB;EEzmBE;;IAkCgB,2BAAA;IACA,0BAAA;IACA,cAAA;EF2kBlB;EE/mBE;IAyCY,mBAAA;EFykBd;EEpkBE;IACI,YAAA;IACA,iBAAA;IACA,kBAAA;EFskBN;EEnkBE;IACI,eAAA;EFqkBN;EElkBE;IACI,gCAAA;EFokBN;EEjkBE;IACI,kCAAA;IACA,sBAAA;IACA,iBAAA;EFmkBN;EACA;;;;MAII;EE/jBF;IACI,WAAA;EFikBN;EE9jBE;IACI,gCAAA;IACA,wBAAA;IACA,2BAAA;IACA,0BAAA;EFgkBN;EE7jBE;IACI,iBAAA;EF+jBN;EEhkBE;;;IAMQ,YAAA;IACA,cAAA;IACA,YAAA;IACA,eAAA;EF+jBV;EExkBE;;;IAYY,cAAA;IACA,eAAA;EFikBd;EE9kBE;IAkBQ,kBAAA;IACA,cAAA;EF+jBV;EEllBE;IAsBY,YAAA;EF+jBd;EErlBE;IA0BY,gBAAA;EF8jBd;EExlBE;IA6BgB,YAAA;EF8jBlB;EE3lBE;;;IAqCQ,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,uCAAA;IF2jBR;;;cAGU;EACZ;EEvjBE;;IACI,iBAAA;IACA,aAAA;EF0jBN;EE5jBE;IAKQ,gBAAA;IACA,SAAA;IACA,WAAA;EF0jBV;EEjkBE;IASY,YAAA;EF2jBd;EEpkBE;IAcQ,gBAAA;IACA,gBAAA;IACA,WAAA;EFyjBV;EEjjBE;IACI,aAAA;EFmjBN;EEhjBE;IACI,sBAAA;EFkjBN;EE/iBE;IACI,cAAA;IACA,mBAAA;EFijBN;EE9iBE;IACI,cAAA;EFgjBN;EE7iBE;IAEQ,gBAAA;EF8iBV;EE1iBE;IACI,YAAA;IACA,kBAAA;EF4iBN;EEziBE;IACI,kBAAA;IACA,wBAAA;IACA,cAAA;IACA,+BAAA;IF2iBJ;;;;;wBAKoB;EACtB;EErjBE;IAYQ,aAAA;IACA,kBAAA;IACA,YAAA;IACA,WAAA;EF4iBV;EE3jBE;IAmBQ,kBAAA;IACA,QAAA;IACA,WAAA;IACA,qBAAA;IACA,cAAA;IACA,eAAA;EF2iBV;EEnkBE;IA4BQ,gBAAA;IACA,sBAAA;IACA,eAAA;EF0iBV;EExkBE;IAkCQ,iBAAA;EFyiBV;AACF;AEriBA;EACI;;;;IAII,eAAA;EFuiBN;EEriBE;IACI,YAAA;EFuiBN;EExiBE;IAGQ,oBAAA;EFwiBV;EEriBE;IACI,UAAA;EFuiBN;EEpiBE;IACI,aAAA;EFsiBN;EEniBE;IACI,SAAA;EFqiBN;EEniBE;IACI,YAAA;EFqiBN;EEliBE;IACI,eAAA;EFoiBN;EEliBE;IACI,WAAA;EFoiBN;EEjiBE;IACI,aAAA;EFmiBN;EEhiBE;IACI,kBAAA;EFkiBN;EE/hBE;IACI,wCAAA;EFiiBN;AACF;AE9hBA;EACI;IFgiBA,yEAAyE;IE9hBrE,eAAA;IACA,uBAAA;EFgiBN;AACF;AACA,4CAA4C;AE7hB5C;EACI;IACI,eAAA;EF+hBN;EE7hBE;IACI,mBAAA;IACA,8BAAA;EF+hBN;EEjiBE;IAKQ,OAAA;EF+hBV;EEpiBE;IASQ,eAAA;IACA,gBAAA;IACA,4BAAA;IACA,cAAA;EF8hBV;EE3hBE;IACI,8BAAA;EF6hBN;AACF;AE1hBA;EACI;IACI,+BAAA;EF4hBN;AACF;AEzhBA;EACI;;;IAGI,wBAAA;EF2hBN;AACF","sourcesContent":["/*! CSS Used fontfaces */\n@font-face {\n  font-family: \"accessgov\";\n  src: url(\"../icons/fonts/accessgov.woff?v=7\") format(\"woff\"), url(\"../icons/fonts/accessgov.ttf?v=7\") format(\"truetype\"), url(\"../icons/fonts/accessgov.svg?v=7#accessgov\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n/*! CSS Used from: ../bootstrap/bootstrap.css?v=-2013962739 */\n:root {\n  --blue: #007bff;\n  --indigo: #6610f2;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #dc3545;\n  --orange: #fd7e14;\n  --yellow: #ffc107;\n  --green: #28a745;\n  --teal: #20c997;\n  --cyan: #17a2b8;\n  --white: #fff;\n  --gray: #6c757d;\n  --gray-dark: #343a40;\n  --primary: #007bff;\n  --secondary: #6c757d;\n  --success: #28a745;\n  --info: #17a2b8;\n  --warning: #ffc107;\n  --danger: #dc3545;\n  --light: #f8f9fa;\n  --dark: #343a40;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\nnav {\n  display: block;\n}\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: left;\n  background-color: #fff;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\nh2,\nh3 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\nul {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\nul ul {\n  margin-bottom: 0;\n}\nsmall {\n  font-size: 80%;\n}\na {\n  color: #466db2;\n  text-decoration: none;\n  background-color: transparent;\n}\na:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([tabindex]):hover,\na:not([href]):not([tabindex]):focus {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([tabindex]):focus {\n  outline: 0;\n}\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\ntable {\n  border-collapse: collapse;\n}\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\nbutton {\n  border-radius: 0;\n}\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\ninput,\nbutton {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\nbutton,\ninput {\n  overflow: visible;\n}\nbutton {\n  text-transform: none;\n}\nbutton,\n[type=\"button\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\nh2,\nh3 {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\nh2 {\n  font-size: 2rem;\n}\nh3 {\n  font-size: 1.75rem;\n}\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\nsmall {\n  font-size: 80%;\n  font-weight: 400;\n}\n.container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 576px) {\n  .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1140px;\n  }\n}\n.container-fluid {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.form-control::-webkit-input-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control::-moz-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control:-ms-input-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control::-ms-input-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.form-group {\n  margin-bottom: 1rem;\n}\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n.form-check-label {\n  margin-bottom: 0;\n}\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #212529;\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: #212529;\n  text-decoration: none;\n}\n.btn:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.btn:disabled {\n  opacity: 0.65;\n}\n.btn-link {\n  font-weight: 400;\n  color: #466db2;\n  text-decoration: none;\n}\n.btn-link:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n.btn-link:focus {\n  text-decoration: underline;\n  box-shadow: none;\n}\n.btn-link:disabled {\n  color: #6c757d;\n  pointer-events: none;\n}\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n.collapse:not(.show) {\n  display: none;\n}\n.dropdown {\n  position: relative;\n}\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n.nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n}\n.nav-link:hover,\n.nav-link:focus {\n  text-decoration: none;\n}\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6;\n}\n.nav-tabs .nav-item {\n  margin-bottom: -1px;\n}\n.nav-tabs .nav-link {\n  border: 1px solid transparent;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n  border-color: #e9ecef #e9ecef #dee2e6;\n}\n.nav-tabs .nav-link.active {\n  color: #495057;\n  background-color: #fff;\n  border-color: #dee2e6 #dee2e6 #fff;\n}\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n.navbar {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n}\n.navbar > .container-fluid {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.3125rem;\n  padding-bottom: 0.3125rem;\n  margin-right: 1rem;\n  font-size: 1.25rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n.navbar-brand:hover,\n.navbar-brand:focus {\n  text-decoration: none;\n}\n.navbar-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n.navbar-collapse {\n  -ms-flex-preferred-size: 100%;\n  flex-basis: 100%;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n.navbar-toggler:hover,\n.navbar-toggler:focus {\n  text-decoration: none;\n}\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    -ms-flex-flow: row nowrap;\n    flex-flow: row nowrap;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-md > .container-fluid {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n.navbar-dark .navbar-brand:hover,\n.navbar-dark .navbar-brand:focus {\n  color: #fff;\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n.navbar-dark .navbar-nav .nav-link:hover,\n.navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.75);\n}\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: 0.5;\n}\n.close:hover {\n  color: #000;\n  text-decoration: none;\n}\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n}\n.popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n  margin: 0 0.3rem;\n}\n.popover .arrow::before,\n.popover .arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n.bs-popover-top {\n  margin-bottom: 0.5rem;\n}\n.bs-popover-top > .arrow {\n  bottom: calc((0.5rem + 1px) * -1);\n}\n.bs-popover-top > .arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-top > .arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fff;\n}\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n.popover-header:empty {\n  display: none;\n}\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #212529;\n}\n.d-none {\n  display: none !important;\n}\n.d-block {\n  display: block !important;\n}\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n}\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n.text-left {\n  text-align: left !important;\n}\n.text-center {\n  text-align: center !important;\n}\n@media print {\n  *,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    box-shadow: none !important;\n  }\n  a:not(.btn) {\n    text-decoration: underline;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  body {\n    min-width: 992px !important;\n  }\n  .container {\n    min-width: 992px !important;\n  }\n  .navbar {\n    display: none;\n  }\n}\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.badge-light {\n  color: #212529;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n/*! CSS Used from: ../DynamicForms/DFStyle_Master.css?v=-2013962739 */\nhtml {\n  min-height: 100%;\n  position: relative;\n}\n.form-control {\n  color: #333333;\n}\n.form-control::-webkit-input-placeholder {\n  color: #999999;\n  opacity: 1;\n}\n.form-control::-moz-placeholder {\n  color: #999999;\n  opacity: 1;\n}\n.form-control:-ms-input-placeholder {\n  color: #999999;\n  opacity: 1;\n}\n.form-control::-ms-input-placeholder {\n  color: #999999;\n  opacity: 1;\n}\n.form-control::placeholder {\n  color: #999999;\n  opacity: 1;\n}\n.nav.navbar-nav {\n  margin: 0;\n}\nnav {\n  display: block;\n}\n@media (max-width: 767px) {\n  body {\n    padding-bottom: 0;\n  }\n}\n/*! CSS Used from: ../icons/style.css?v=7 */\n.icon:before {\n  font-family: accessgov !important;\n  speak: never;\n  font-style: normal;\n  font-weight: 400;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.icon-info:before {\n  content: \"\\62\";\n}\n.icon-search:before {\n  content: \"\\49\";\n}\n.icon-close:before {\n  content: \"\\74\";\n}\n.icon-user-solid:before {\n  content: \"\\e90d\";\n}\n@font-face {\n  font-style: normal;\n  font-weight: 400;\n  src: local(\"Open Sans Regular\"), local(\"OpenSans-Regular\"), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFUZ0bbck.woff2) format(\"woff2\");\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* variables for easier Custom Less modification */\nhtml {\n  position: relative;\n  min-height: 100vh;\n}\nbody {\n  padding-top: 70px;\n  background: #fff;\n  background-size: cover;\n  font-weight: normal;\n  font-family: \"Open Sans\", sans-serif;\n}\n.body-content {\n  width: 100%;\n  position: relative;\n}\na {\n  color: #466db2;\n}\na:hover {\n  cursor: pointer;\n  color: #304b7b;\n}\np {\n  clear: none;\n}\nh1 {\n  line-height: 1;\n  color: #333;\n}\nh1,\nh2,\nh3 {\n  margin-top: 10px;\n  font-weight: 500;\n}\nh1 {\n  font-size: 1.9rem;\n}\nh2 {\n  font-size: 1.65rem;\n}\nh3 {\n  font-size: 1.45rem;\n}\nh4 {\n  font-size: 1.3rem;\n}\nh5 {\n  font-size: 1.15rem;\n}\nh6 {\n  font-size: 1rem;\n}\n.pull-right {\n  float: right;\n}\n.loading {\n  margin: 15px auto;\n  display: block;\n  margin: 0 auto;\n  height: 100px;\n}\n.text-smaller {\n  font-size: 0.875rem;\n}\n.tile {\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 15px;\n}\n[data-bind*=\"clickOrEnter\"],\n[data-bind^=\"clickOrEnter\"] {\n  cursor: pointer;\n}\n.dropdown-menu li,\n.returning_user li {\n  list-style-type: none;\n  list-style-position: initial;\n}\n.previous-question {\n  padding: 5px 10px;\n  border-top: 1px solid #ddd;\n  font-size: 13px;\n  cursor: pointer;\n}\n.previous-question strong {\n  font-size: 15px;\n}\n.current-question {\n  border-top: 1px solid #ddd;\n}\n.answer.disabled {\n  opacity: 0.65;\n}\n.previous-question:hover,\n.previous-question:focus {\n  background: #f5f5f5;\n}\n.dropdown-menu {\n  border-radius: 0 0 6px 6px;\n}\n.dropdown.open .dropdown-menu {\n  opacity: 1;\n}\n.dropdown-toggle.show + .dropdown-menu {\n  display: block;\n}\nlabel {\n  font-weight: 500;\n}\n#jsPageEditor .form-control,\n#jsPageEditor .vs__dropdown-toggle,\n#jsPageEditor .form-group .input-group .input-group-text {\n  font-weight: normal;\n  border-color: #787878;\n}\n#jsPageEditor .vs__dropdown-toggle .vs__open-indicator {\n  fill: #333333;\n}\n#jsPageEditor .form-control:focus,\n#jsPageEditor .vs--open .vs__dropdown-toggle {\n  border-width: 2px;\n  border-color: rgba(0, 0, 0, 0.87);\n  box-shadow: unset;\n}\n#jsPageEditor .form-control:focus ~ .vs__dropdown-menu,\n#jsPageEditor .vs--open .vs__dropdown-toggle ~ .vs__dropdown-menu {\n  --vs-border-width: 0;\n}\n#jsPageEditor .form-group .btn-group {\n  border-radius: 0.35rem;\n}\n#jsPageEditor .form-group.text-form-group .input-group-append .input-group-text:focus,\n#jsPageEditor .form-group.text-form-group .input-group-prepend .input-group-text:focus {\n  z-index: 0;\n}\n#jsPageEditor .form-group.has-custom-errors .border-mixin {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n}\n#jsPageEditor .form-group.has-custom-errors .border-focus-mixin {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors .invalid-border-mixin {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n}\n#jsPageEditor .form-group.has-custom-errors .invalid-border-mixin:focus {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .form-control,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .form-control,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-text {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .form-control:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .form-control:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-text:focus {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text:focus {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text:focus {\n  outline: 2px solid #b00020;\n  box-shadow: unset;\n  border: unset;\n  z-index: 0;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append:not(.input-group-prepend) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append:not(.input-group-prepend) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend:not(.input-group-prepend) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend:not(.input-group-prepend) .input-group-text {\n  border-left-width: 0;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append:not(.input-group-append) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append:not(.input-group-append) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend:not(.input-group-append) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend:not(.input-group-append) .input-group-text {\n  border-right-width: 0;\n}\n#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > select.form-control,\n#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > .v-select .vs__dropdown-toggle {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > .v-select.vs--open .vs__dropdown-toggle {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-file,\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n  border-width: 2px;\n}\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-file:focus,\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group:focus {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group {\n  border-style: solid;\n}\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group a.btn {\n  border-width: 0;\n}\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group .input-group-append {\n  border-top-width: 0;\n  border-right-width: 0;\n  border-bottom-width: 0;\n}\n.form-check-label,\n.radio-inline,\n.checkbox label {\n  font-weight: normal;\n  margin-bottom: 0;\n}\n.page-loading {\n  position: fixed;\n  opacity: 1;\n  transition: all 0.4s ease-in;\n}\nhtml.no-js .page-loading {\n  display: none;\n}\n.page-loaded {\n  opacity: 0;\n  height: 0;\n  transition: none;\n  /*ensure wheel doesn't fade out, rather disappears*/\n  z-index: -1;\n}\n.body-loading {\n  width: 100px;\n  height: 100px;\n  border-radius: 1.5ex;\n  padding: 0.2ex;\n  position: fixed;\n  left: calc(50% - 50px);\n  top: calc(50% - 50px);\n}\n.body-loading .loading {\n  height: 100%;\n}\n.popover-header {\n  margin: 0;\n}\n.popper {\n  background: #ffffff;\n  max-width: 300px;\n  border: 1px solid #cccccc;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  padding: 7.5px;\n}\n.form-check.answer {\n  position: static;\n}\n.v--modal-overlay {\n  z-index: 1002;\n}\n.modal-content {\n  border: none;\n  max-height: 100vh;\n  overflow-y: auto;\n}\n/* ------------------------\n NAVIGATION\n-/----------------------- */\n.skip-navigation-link:focus {\n  display: block;\n  top: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 998999;\n  background: white;\n  clip: unset;\n}\n.navbar-dark {\n  background-color: #2b2b2b;\n  /*min-height: 60px;*/\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.navbar-dark {\n  padding-left: 0;\n  padding-right: 0;\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.9);\n  cursor: pointer;\n}\n.navbar-dark .navbar-nav .nav-link:hover,\n.navbar-dark .navbar-nav .nav-link:focus {\n  color: #ffffff;\n}\n.navbar-dark .nav-link:focus,\n.navbar-dark .nav-link:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: -2px;\n  box-shadow: none;\n}\n.navbar-dark a {\n  white-space: nowrap;\n}\n.navbar-dark a:hover,\n.navbar-dark a:focus {\n  text-decoration: none;\n}\n.icon-bar {\n  display: block;\n  background: #ffffff;\n  height: 1px;\n  width: 18px;\n  margin-top: 5px;\n}\n.navbar-fixed-top .navbar-collapse,\n.navbar-fixed-bottom .navbar-collapse {\n  max-height: none;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  width: 100%;\n}\n.navbar-dark .navbar-nav > li > a {\n  color: #fff;\n  font-size: 15px;\n  text-decoration: none;\n  display: inline-block;\n  letter-spacing: 0.5px;\n  /*text-transform: uppercase;*/\n}\n.navbar-dark .navbar-nav > li {\n  padding: 13px 7.5px;\n}\n.navbar-dark .navbar-nav > li button {\n  margin-bottom: 0;\n}\n.navbar-dark .navbar-nav > li ::-webkit-input-placeholder,\n.navbar-dark .navbar-nav > li :-moz-placeholder,\n.navbar-dark .navbar-nav > li ::-moz-placeholder,\n.navbar-dark .navbar-nav > li :-ms-input-placeholder {\n  color: #fff !important;\n  opacity: 1 !important;\n}\nfieldset {\n  border: none;\n  padding: 0;\n  margin: 0;\n}\nlegend {\n  font-size: 1.2em;\n  font-weight: 500;\n}\n.navbar-dark .navbar-nav > .vr {\n  height: 50px;\n  width: 1px;\n  margin-top: 5px;\n  margin-left: 7px;\n  padding-left: 0;\n  padding-right: 7px;\n  border-left: 1px solid #3e3e3e;\n}\n.navbar-dark .navbar-nav > li:not(.active) > a:hover,\n.navbar-dark .navbar-nav > li > a:focus,\n.navbar-dark .navbar-nav > li:focus,\n.navbar-dark .navbar-nav > li.open > a:hover,\n.navbar-dark .navbar-nav > li.open > a:focus,\n.navbar-dark .navbar-nav > li.open > a:active,\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus,\n.dropdown-menu > li > a:active {\n  color: #fff;\n  background: #2b2b2b;\n  border-color: transparent;\n}\n.navbar-dark .navbar-nav > .open > a:hover,\n.navbar-dark .navbar-nav > .open > a:focus {\n  background: #27221a;\n}\n.navbar-dark .navbar-brand {\n  padding: 0;\n  /* cspell:ignore ccess */\n}\n.navbar-dark .navbar-brand img {\n  height: 50px;\n  display: inline;\n}\n.navbar-dark .navbar-brand .brand-letters {\n  display: inline;\n  margin-left: 4px;\n}\n.navbar-dark .navbar-brand .brand-letters img {\n  height: 25px;\n}\n.navbar-dark .navbar-brand .brand-letters-ccess,\n.navbar-dark .navbar-brand .brand-letters-gov {\n  font-size: 40px;\n  letter-spacing: 6pt;\n  vertical-align: middle;\n  display: inline-block;\n  margin-top: -1px;\n}\n.navbar-dark .navbar-brand .brand-letters-ccess {\n  font-weight: bold;\n  color: #ccc;\n}\n.navbar-dark .navbar-brand .brand-letters-gov {\n  color: #fff;\n}\n.navbar-dark .navbar-right {\n  font-size: 1.1em;\n  letter-spacing: 0.4pt;\n  margin: 0;\n  margin-right: -15px;\n  margin-left: auto;\n}\n.form-control.search-control {\n  background: transparent url(\"../images/search.png\") no-repeat center left 7.5px;\n  background-size: 15px;\n  padding-left: 30px;\n}\n.navbar-dark .form-control.search-control:focus {\n  border-bottom-color: #fff;\n}\n.search-backdrop,\n.my-forms-backdrop {\n  /*display: none;*/\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.9);\n  z-index: 10000;\n}\n.search-backdrop .close {\n  position: fixed;\n  top: 30px;\n  right: 30px;\n  color: #fff;\n  font-size: 2em;\n  opacity: 1;\n}\n.search-backdrop .close img {\n  height: 20px;\n}\n.search-backdrop .search-form-wrapper {\n  width: 600px;\n  height: 100px;\n  max-width: 100%;\n  position: fixed;\n  top: 25vh;\n  left: calc(50% - 300px);\n}\n.search-backdrop .search-form-wrapper .form-group label {\n  font-size: 1.5em;\n  color: #aaa;\n  margin-bottom: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.search-backdrop .search-form-wrapper .form-group .form-control {\n  background: none;\n  height: 40px;\n  color: #ddd;\n  border: none;\n  padding: 10px;\n  border-bottom: 1px solid #aaa;\n  border-radius: 0;\n  box-shadow: none;\n}\n.search-backdrop .search-form-wrapper .form-group .form-control:focus {\n  border-color: #466db2;\n  border-bottom-width: 2px;\n}\n.nav-search-results {\n  position: relative;\n  height: auto;\n  max-height: calc(75vh - 125px);\n  min-height: 75px;\n  overflow-y: auto;\n  width: 600px;\n  max-width: 100%;\n  background: #fff;\n  margin-top: 0;\n  padding: 0;\n  border-radius: 4px;\n  box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.25);\n  overflow: auto;\n}\n.nav-search-results .nav-search-results-inner {\n  padding: 15px;\n  position: relative;\n  height: auto;\n  width: 100%;\n  overflow-x: hidden;\n  text-align: left;\n}\n.nav-search-results .nav-search-results-caption {\n  position: absolute;\n  top: 5px;\n  right: 10px;\n  display: inline-block;\n  color: #636363;\n  font-size: 12px;\n  /*font-weight: 600;*/\n}\n.nav-search-results .result {\n  padding-top: 5px;\n  letter-spacing: normal;\n  /*font-size: 14px;*/\n  text-align: left;\n}\n.nav-search-results .result:first-of-type {\n  padding-top: 10px;\n}\n.close {\n  opacity: 0.7;\n  font-size: 1.25em;\n}\n.dropdown-menu {\n  padding: 0;\n  padding-bottom: 8px;\n}\n.dropdown-menu > li > a {\n  display: block;\n  color: #fff;\n  font-size: 13px;\n  padding: 6px 18px;\n}\n.dropdown-menu .divider {\n  opacity: 0.3;\n  background-color: #000000;\n  margin: 0;\n  display: none;\n}\n.pane-size-toggle {\n  font-size: 32px;\n  margin-top: -10px;\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  float: right;\n}\n.toolbox_pane .pane-size-toggle {\n  margin-top: -14px;\n}\n.toggle-symbol {\n  font-size: 24px;\n  margin-top: -10px;\n}\n.toggle-smaller {\n  margin-left: 7px;\n}\n.toggle-larger {\n  margin-left: 0;\n}\n.pane-size-toggle.close:hover {\n  opacity: 1;\n}\n.df-public-nav .navbar {\n  min-height: 0;\n}\n.navbar-toggle.public_pages_toggle {\n  margin: 5px;\n  padding: 5px;\n}\n.navbar-collapse .list-group {\n  margin-bottom: 0;\n}\n.btn .icon {\n  line-height: 0;\n  vertical-align: inherit;\n}\n.btn .icon-trash {\n  font-size: 1.1em;\n}\n.btn .icon-undo,\n.btn .icon-redo {\n  font-size: 1.15em;\n}\n.btn-link {\n  color: #466db2;\n}\n.btn-link.icon:active,\n.btn-link.icon:focus {\n  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);\n}\n.btn-group-vertical .btn {\n  margin-bottom: 0;\n}\n.fixed-top {\n  z-index: 1001;\n}\n.btn-primary {\n  background: #234d7f;\n  color: #fff;\n  border-color: transparent;\n}\n.btn-primary:hover {\n  background: #3471bb;\n  border-color: #3471bb;\n  color: #fff;\n}\n.btn-primary:focus {\n  outline: 2px solid #3471bb;\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn-primary:active {\n  background: #3471bb !important;\n  color: #fff !important;\n  border-color: #183557;\n}\n.btn-outline-primary:hover {\n  background: #234d7f;\n  border-color: #234d7f;\n}\n.btn-outline-primary:focus {\n  background: #234d7f;\n  color: #fff;\n  outline: 2px solid #234d7f;\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn-outline-secondary:focus {\n  background: #6c757d;\n  color: #ffffff;\n  outline: 2px solid #6c757d;\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn-outline-danger:focus {\n  background: #dc3545;\n  color: #ffffff;\n  outline: 2px solid #dc3545;\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn-outline-success:focus {\n  background: #28a745;\n  color: #ffffff;\n  outline: 2px solid #28a745;\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn-bare:focus {\n  outline: 2px solid rgba(0, 0, 0, 0.87);\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn.btn-xs {\n  padding: 2px 5px;\n  font-size: 0.75rem;\n  border-radius: 3px;\n  -webkit-transition: 0.1s all ease-in-out;\n  -moz-transition: 0.1s all ease-in-out;\n  -o-transition: 0.1s all ease-in-out;\n  transition: 0.1s all ease-in-out;\n}\n.notificationBarTop {\n  background: #ffc107;\n  color: #121212;\n  text-align: center;\n  line-height: 2.5;\n  overflow: hidden;\n  /*margin-top: -15px;\n    margin-bottom: 15px;*/\n}\n.notificationBarTop a,\n.notificationBarTop button:not(.close) {\n  color: #121212;\n  font-weight: bold;\n  border-bottom: 1px solid #121212;\n  border-radius: 0;\n  padding: 0;\n}\n.notificationBarTop a:hover,\n.notificationBarTop button:not(.close):hover {\n  color: #0a0c0d;\n}\n.notificationBarTop button:not(.close) {\n  text-decoration: none;\n}\n.notificationBarTop .close {\n  color: #eeeeee;\n  padding: 7px 10px;\n  opacity: 0.8;\n  font-size: 1.3em;\n}\n.notificationBarTop .close:hover {\n  opacity: 1;\n}\n.notificationBarTop .close:not(:disabled):not(.disabled):hover,\n.notificationBarTop .close:not(:disabled):not(.disabled):focus {\n  color: #fff;\n  opacity: 0.75;\n}\n.tab-content .result {\n  border-bottom: 1px solid #ddd;\n  padding: 15px;\n}\n.tab-content .result:first-of-type {\n  border-top: 1px solid #ddd;\n}\n.form-group {\n  margin-bottom: 0.75rem;\n  /*label.focused {\n        color: @focus;\n    }*/\n}\n.form-group label.sr-only {\n  position: absolute;\n}\n.form-group legend {\n  font-size: 1em;\n  font-weight: 600;\n  border-bottom: none;\n  margin-bottom: 2px;\n}\n.form-group .radio-inline,\n.form-group .checkbox-inline,\n.form-group .checkbox label,\n.form-group .radio label {\n  margin-left: 0;\n  margin-right: 10px;\n}\n/*.radio-inline,\n.radio,\n.checkbox-inline,\n.checkbox {\n    font-size: 14px;\n}*/\n.loading {\n  margin: 15px auto;\n  display: block;\n  margin: 0 auto;\n  height: 100px;\n}\n.have_not_searched {\n  text-align: center;\n  height: 100%;\n  width: 100%;\n  /*padding-top: 15px;*/\n}\n.have_not_searched:before {\n  /*content: \"Use this search tool to find forms.\";*/\n  font-size: 1.2em;\n  vertical-align: middle;\n}\n#questionsDiv {\n  position: relative;\n  margin-bottom: 20px;\n}\n#questionsDiv .radio {\n  margin-bottom: 7px;\n}\n.public-page-body .body-content {\n  padding: 0;\n}\n/* ------------------------\n AUTHENTICATED USER\n------------------------ */\n.index-container {\n  display: flex;\n  flex: 1;\n  flex-direction: column-reverse;\n}\n.index-content legend {\n  display: block;\n  width: 100%;\n  text-align: center;\n}\n.returning_user {\n  overflow: auto;\n  flex: 0 0 100%;\n  padding: 0px 15px 15px 15px;\n  background: #f9f9f9;\n  border-top: 1px solid #ccc;\n}\n.returning_user .returning_user_header,\n.returning_user .returning_user_body {\n  visibility: visible;\n}\n.returning_user .nav-tabs {\n  border-bottom-color: #bbbbbb;\n}\n.returning_user .nav-tabs li button {\n  background: none !important;\n}\n.returning_user .badge {\n  margin-left: 5px;\n}\n.returning_user .tab-content {\n  padding: 4px 0;\n  border: none;\n  border-top: none;\n}\n.returning_user .returning_user_list_of_forms {\n  list-style: none;\n  padding: 0;\n}\n.returning_user .returning_user_list_of_forms li {\n  position: relative;\n  display: table;\n  width: 100%;\n  padding: 0.5rem;\n  border-bottom: 1px solid #ccc;\n}\n.returning_user .returning_user_list_of_forms li .returning_user_actions {\n  float: right;\n  display: block;\n}\n#MyFormsHeading {\n  margin-top: 15px;\n  margin-bottom: 10px;\n}\n.submitted_timestamp {\n  font-size: 12px;\n  color: #6d6d6d;\n  float: left;\n  margin-top: 5px;\n}\n.my-forms-tag {\n  display: block;\n  clear: both;\n  padding: 2px 6px;\n  border-radius: 100px;\n  font-size: 80%;\n  margin-top: 5px;\n  margin-bottom: 2.5px;\n  float: left;\n}\n.my-forms-tag.returned {\n  background: #ffebce;\n}\n.my-forms-tag.in-progress {\n  background: #e0edff;\n}\n.my-forms-tag.done {\n  background: #dbf2e4;\n}\n.my-forms-tag.unavailable {\n  background: #ffe0e0;\n}\n.badge {\n  font-weight: 600;\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.badge-primary {\n  color: #fff;\n  background-color: #007bff;\n}\n.badge-light {\n  border: 1px solid #dee2e6;\n}\ndiv .nav-tabs {\n  margin-right: 0;\n}\n.nav-tabs > li > .nav-link {\n  border: none;\n  border-bottom: 3px solid transparent;\n}\n.nav-tabs > li > .nav-link.active,\n.nav-tabs > li > .nav-link.active:hover,\n.nav-tabs > li > .nav-link.active:focus {\n  border-bottom: 3px solid #466db2;\n  background-color: #fff;\n  border-radius: 0;\n  color: #466db2 !important;\n  border-bottom-color: #466db2 !important;\n}\n/*.nav-tabs > li.active > .nav-link.show {\n    border-bottom-color: transparent;\n}\n\n.nav-tabs > li.active > .nav-link,\n.nav-tabs > li.active > .nav-link:hover,\n.nav-tabs > li.active > .nav-link:focus {\n    border-bottom: 3px solid @focus;\n    background-color: #fff;\n    border-radius: 0;\n    color: @focus !important;\n    border-bottom-color: @focus !important;\n\n    .badge {\n        background-color: #333;\n    }\n}*/\n.nav-tabs > li {\n  margin-bottom: -1px;\n}\n.nav-tabs > li > .nav-link,\n.nav-tabs > li > .nav-link:hover {\n  color: inherit;\n  margin-right: 0;\n  background-color: transparent;\n}\n#myFormsDiv {\n  max-height: 495px;\n  overflow: auto;\n}\n#myFormsDiv ul {\n  padding-left: 20px;\n}\n#myFormsDiv li {\n  margin-bottom: 10px;\n}\n.navbar-dark .navbar-nav > li.login > a img,\n.navbar-dark .navbar-nav > li.login.dropdown > a img {\n  height: 20px;\n  margin-right: 5px;\n}\n.navbar-dark .navbar-nav > li > a,\n.navbar-dark .navbar-nav > li > a:hover,\n.navbar-dark .navbar-nav > li > a:focus {\n  color: #fff;\n  background: transparent;\n}\n.navbar-dark .navbar-nav > li .dropdown-menu {\n  background-color: #2b2b2b;\n  border: 0;\n  left: auto;\n  right: 0;\n}\n.navbar-dark .navbar-nav > li .dropdown-menu > li > a,\n.navbar-dark .navbar-nav > li .dropdown-menu > li {\n  color: #fff;\n  /*text-transform: uppercase;*/\n}\n.nav .open > a,\n.nav .open > a:hover,\n.nav .open > a:focus {\n  border-color: transparent;\n}\n.help-block {\n  color: #717171;\n  font-size: 13px;\n}\n/*----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/\n/* ------------------------\n FOOTER\n------------------------ */\n#demo {\n  width: 600px;\n  padding-top: 5px;\n  margin-left: 10px;\n  float: left;\n}\n#demo a,\na.visited,\na.hover {\n  text-decoration: none;\n  border: none;\n}\n#footer {\n  background: #2b2b2b;\n  color: rgba(255, 255, 255, 0.9);\n  width: 100%;\n}\n#footer ul {\n  padding: 24px 20px;\n  list-style-type: none;\n  text-align: center;\n  list-style: none outside none;\n  z-index: 11;\n  bottom: 0px;\n  margin: 0px auto;\n  flex: auto;\n  display: inline;\n}\n#footer ul li {\n  margin: 0 5px;\n  display: inline-block;\n  color: #e2d5b4;\n}\n#footer ul li a {\n  background: none;\n  color: #fff;\n  letter-spacing: normal;\n  font-size: 12px;\n}\n#footer ul li:first-of-type {\n  margin-left: 0;\n}\n#footer ul li:last-of-type {\n  margin-right: 0;\n}\n#footer ul li:hover {\n  background: none;\n  color: #e2d5b4;\n}\n#footer > a {\n  margin-left: auto;\n  max-height: 48px;\n  border: none;\n}\n.mi-footer-logo {\n  height: 35px;\n  margin-top: -6px;\n}\n.accessgov-footer-logo {\n  height: 45px;\n  margin-top: -10px;\n}\n.visible-xs-inline-block {\n  display: none;\n}\n.my-forms-backdrop {\n  background: rgba(0, 0, 0, 0.5);\n  height: 100vh;\n  width: 100%;\n  z-index: 999;\n}\n.index-logo {\n  height: 150px;\n  margin: 10px auto;\n  max-width: 100%;\n}\n.public-page-body .tile {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.public-page-body .body-content {\n  padding: 0 5px;\n}\n@media (max-width: 767px) {\n  body {\n    padding-top: 60px;\n    background-image: none;\n    padding-bottom: 0 !important;\n  }\n  .body-content {\n    margin-top: 0;\n    padding-top: 0;\n  }\n  .transitions-after-load .body-content {\n    height: 100vh;\n  }\n  .nav .dropdown {\n    position: static;\n  }\n  .dropdown-menu {\n    position: static;\n    box-shadow: none;\n  }\n  .notificationBarTop {\n    /*margin-top: -10px;*/\n    margin-bottom: 0;\n  }\n  #footer {\n    position: static;\n    text-align: center;\n    height: auto;\n    /*margin-top: 25px;*/\n    padding: 15px 0;\n    display: block;\n  }\n  #footer ul {\n    display: block;\n    width: 90%;\n  }\n  #footer ul li {\n    display: block;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  #footer ul li a:link,\n  #footer ul li a {\n    /*background: @primary-light;*/\n    float: none;\n    margin: 0.5em 0px;\n    padding: 1.2em 0 1.2em;\n    height: auto;\n    display: block;\n    margin-bottom: 5px;\n    /*color: #fff;*/\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  #footer ul li a:link:hover,\n  #footer ul li a:hover {\n    background: #eee !important;\n    text-decoration: underline;\n    color: #2b2b2b;\n  }\n  #footer ul li:hover a {\n    background: #454545;\n  }\n  #questionsDiv {\n    height: auto;\n    padding-bottom: 0;\n    position: relative;\n  }\n  .form-control {\n    max-width: none;\n  }\n  .visible-xs-inline-block {\n    display: inline-block !important;\n  }\n  .have_not_searched {\n    background-position: center center;\n    background-size: 150px;\n    padding-top: 30px;\n  }\n  /*.dfNavButton:not(.dfNavRemoveButton) {\n        display: block;\n        width: 100%;\n        margin-bottom: 5px;\n    }*/\n  .dropdown-toggle {\n    width: 100%;\n  }\n  .pane-size-toggle {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    margin-top: -8px !important;\n    margin-right: 0 !important;\n  }\n  .navbar-dark {\n    padding: 13px 5px;\n  }\n  .navbar-dark a.search-toggle,\n  .navbar-dark a.search-toggle:hover,\n  .navbar-dark a.search-toggle:focus {\n    float: right;\n    color: #ffffff;\n    opacity: 0.8;\n    padding: 0 10px;\n  }\n  .navbar-dark a.search-toggle .icon,\n  .navbar-dark a.search-toggle:hover .icon,\n  .navbar-dark a.search-toggle:focus .icon {\n    display: block;\n    margin-top: 2px;\n  }\n  .navbar-dark .navbar-brand {\n    width: min-content;\n    margin: 0 auto;\n  }\n  .navbar-dark .navbar-brand img {\n    height: 33px;\n  }\n  .navbar-dark .navbar-brand .brand-letters {\n    margin-left: 3px;\n  }\n  .navbar-dark .navbar-brand .brand-letters img {\n    height: 15px;\n  }\n  .navbar-dark .navbar-toggler,\n  .navbar-dark .navbar-toggler:focus,\n  .navbar-dark .navbar-toggler:hover {\n    background: #2b2b2b;\n    border: none;\n    box-shadow: none;\n    padding: 0.25rem 0.75rem 0.5rem 0.75rem;\n    /*.navbar-toggler-icon {\n                width: 20px;\n                height: 20px;\n            }*/\n  }\n  .search-backdrop,\n  .my-forms-backdrop {\n    padding: 5px 15px;\n    height: 150vh;\n  }\n  .search-backdrop .close {\n    font-size: 1.4em;\n    top: 15px;\n    right: 15px;\n  }\n  .search-backdrop .close img {\n    height: 15px;\n  }\n  .search-backdrop .search-form-wrapper {\n    position: static;\n    margin-top: 40px;\n    width: 100%;\n  }\n  .navbar-dark .navbar-nav > .vr {\n    display: none;\n  }\n  .navbar-dark .form-group.search-group .search-control {\n    width: 100% !important;\n  }\n  .navbar-dark .navbar-left {\n    margin-left: 0;\n    margin-right: -15px;\n  }\n  .navbar-dark .navbar-nav > li {\n    padding: 0 7px;\n  }\n  .navbar-dark .icon-search {\n    font-size: 1.4em;\n  }\n  #collapse2 {\n    padding: 8px;\n    overflow-x: hidden;\n  }\n  .nav-search-results {\n    position: relative;\n    width: calc(100% - 30px);\n    z-index: 10000;\n    max-height: calc(100vh - 150px);\n    /*background: #fff;\n        margin-top: 0;\n        padding: 0;\n        border: 1px solid #ddd;\n        box-shadow: 0 2px 6px 1px rgba(0,0,0,.25);\n        overflow: auto;*/\n  }\n  .nav-search-results .nav-search-results-inner {\n    padding: 15px;\n    position: relative;\n    height: auto;\n    width: 100%;\n  }\n  .nav-search-results .nav-search-results-caption {\n    position: absolute;\n    top: 5px;\n    right: 10px;\n    display: inline-block;\n    color: #717171;\n    font-size: 11px;\n  }\n  .nav-search-results .result {\n    padding-top: 5px;\n    letter-spacing: normal;\n    font-size: 13px;\n  }\n  .nav-search-results .result:first-of-type {\n    padding-top: 10px;\n  }\n}\n@media (min-width: 768px) {\n  body,\n  label,\n  .btn,\n  .form-control {\n    font-size: 15px;\n  }\n  .navbar-dark {\n    height: 70px;\n  }\n  .navbar-dark .navbar-brand {\n    pointer-events: none;\n  }\n  .public-page-body .body-content {\n    padding: 0;\n  }\n  .index-content {\n    padding: 15px;\n  }\n  .returning_user {\n    margin: 0;\n  }\n  .mi-footer-logo {\n    float: right;\n  }\n  .lead {\n    font-size: 16px;\n  }\n  .accessgov-footer-logo {\n    float: left;\n  }\n  .my-forms-backdrop {\n    display: none;\n  }\n  #collapse2 {\n    margin-right: 10px;\n  }\n  .navbar-inverse .navbar-nav > li .dropdown-menu {\n    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);\n  }\n}\n@media (max-width: 991px) {\n  .img-responsive {\n    /* account for large homepage images to be responsive on mobile devices */\n    max-width: 100%;\n    height: auto !important;\n  }\n}\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n  .lead {\n    font-size: 17px;\n  }\n  .index-container {\n    flex-direction: row;\n    min-height: calc(100vh - 70px);\n  }\n  .index-container .index-content {\n    flex: 1;\n  }\n  .index-container .returning_user {\n    flex: 0 0 375px;\n    border-top: none;\n    border-right: 1px solid #ccc;\n    overflow: auto;\n  }\n  .body-content {\n    min-height: calc(100vh - 70px);\n  }\n}\n@media (min-width: 1200px) {\n  .have_not_searched {\n    background-position: center 40%;\n  }\n}\n@media print {\n  .no_print,\n  #footer,\n  .btn {\n    display: none !important;\n  }\n}\n","/*! CSS Used fontfaces */\n@font-face {\n    font-family: \"accessgov\";\n    src:\n        url(\"../icons/fonts/accessgov.woff?v=7\") format(\"woff\"),\n        url(\"../icons/fonts/accessgov.ttf?v=7\") format(\"truetype\"),\n        url(\"../icons/fonts/accessgov.svg?v=7#accessgov\") format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n}\n/*! CSS Used from: ../bootstrap/bootstrap.css?v=-2013962739 */\n:root {\n    --blue: #007bff;\n    --indigo: #6610f2;\n    --purple: #6f42c1;\n    --pink: #e83e8c;\n    --red: #dc3545;\n    --orange: #fd7e14;\n    --yellow: #ffc107;\n    --green: #28a745;\n    --teal: #20c997;\n    --cyan: #17a2b8;\n    --white: #fff;\n    --gray: #6c757d;\n    --gray-dark: #343a40;\n    --primary: #007bff;\n    --secondary: #6c757d;\n    --success: #28a745;\n    --info: #17a2b8;\n    --warning: #ffc107;\n    --danger: #dc3545;\n    --light: #f8f9fa;\n    --dark: #343a40;\n    --breakpoint-xs: 0;\n    --breakpoint-sm: 576px;\n    --breakpoint-md: 768px;\n    --breakpoint-lg: 992px;\n    --breakpoint-xl: 1200px;\n    --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\nhtml {\n    font-family: sans-serif;\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\nnav {\n    display: block;\n}\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    text-align: left;\n    background-color: #fff;\n}\nhr {\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n}\nh2,\nh3 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n}\np {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\nul {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\nul ul {\n    margin-bottom: 0;\n}\nsmall {\n    font-size: 80%;\n}\na {\n    color: #466db2;\n    text-decoration: none;\n    background-color: transparent;\n}\na:hover {\n    color: #0056b3;\n    text-decoration: underline;\n}\na:not([href]):not([tabindex]) {\n    color: inherit;\n    text-decoration: none;\n}\na:not([href]):not([tabindex]):hover,\na:not([href]):not([tabindex]):focus {\n    color: inherit;\n    text-decoration: none;\n}\na:not([href]):not([tabindex]):focus {\n    outline: 0;\n}\nimg {\n    vertical-align: middle;\n    border-style: none;\n}\ntable {\n    border-collapse: collapse;\n}\nlabel {\n    display: inline-block;\n    margin-bottom: 0.5rem;\n}\nbutton {\n    border-radius: 0;\n}\nbutton:focus {\n    outline: 1px dotted;\n    outline: 5px auto -webkit-focus-ring-color;\n}\ninput,\nbutton {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n}\nbutton,\ninput {\n    overflow: visible;\n}\nbutton {\n    text-transform: none;\n}\nbutton,\n[type=\"button\"] {\n    -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner {\n    padding: 0;\n    border-style: none;\n}\ninput[type=\"radio\"] {\n    box-sizing: border-box;\n    padding: 0;\n}\nfieldset {\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0;\n}\nlegend {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n    margin-bottom: 0.5rem;\n    font-size: 1.5rem;\n    line-height: inherit;\n    color: inherit;\n    white-space: normal;\n}\n[type=\"search\"] {\n    outline-offset: -2px;\n    -webkit-appearance: none;\n}\nh2,\nh3 {\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\nh2 {\n    font-size: 2rem;\n}\nh3 {\n    font-size: 1.75rem;\n}\nhr {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\nsmall {\n    font-size: 80%;\n    font-weight: 400;\n}\n.container {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n}\n@media (min-width: 576px) {\n    .container {\n        max-width: 540px;\n    }\n}\n@media (min-width: 768px) {\n    .container {\n        max-width: 720px;\n    }\n}\n@media (min-width: 992px) {\n    .container {\n        max-width: 960px;\n    }\n}\n@media (min-width: 1200px) {\n    .container {\n        max-width: 1140px;\n    }\n}\n.container-fluid {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n}\n.form-control {\n    display: block;\n    width: 100%;\n    height: ~\"calc(1.5em + 0.75rem + 2px)\";\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition:\n        border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n    .form-control {\n        transition: none;\n    }\n}\n.form-control::-ms-expand {\n    background-color: transparent;\n    border: 0;\n}\n.form-control:focus {\n    color: #495057;\n    background-color: #fff;\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.form-control::-webkit-input-placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n.form-control::-moz-placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n.form-control:-ms-input-placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n.form-control::-ms-input-placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n.form-control::placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n.form-control:disabled {\n    background-color: #e9ecef;\n    opacity: 1;\n}\n.form-group {\n    margin-bottom: 1rem;\n}\n.form-check {\n    position: relative;\n    display: block;\n    padding-left: 1.25rem;\n}\n.form-check-input {\n    position: absolute;\n    margin-top: 0.3rem;\n    margin-left: -1.25rem;\n}\n.form-check-label {\n    margin-bottom: 0;\n}\n.btn {\n    display: inline-block;\n    font-weight: 400;\n    color: #212529;\n    text-align: center;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid transparent;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: 0.25rem;\n    transition:\n        color 0.15s ease-in-out,\n        background-color 0.15s ease-in-out,\n        border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n    .btn {\n        transition: none;\n    }\n}\n.btn:hover {\n    color: #212529;\n    text-decoration: none;\n}\n.btn:focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.btn:disabled {\n    opacity: 0.65;\n}\n.btn-link {\n    font-weight: 400;\n    color: #466db2;\n    text-decoration: none;\n}\n.btn-link:hover {\n    color: #0056b3;\n    text-decoration: underline;\n}\n.btn-link:focus {\n    text-decoration: underline;\n    box-shadow: none;\n}\n.btn-link:disabled {\n    color: #6c757d;\n    pointer-events: none;\n}\n.fade {\n    transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n    .fade {\n        transition: none;\n    }\n}\n.fade:not(.show) {\n    opacity: 0;\n}\n.collapse:not(.show) {\n    display: none;\n}\n.dropdown {\n    position: relative;\n}\n.dropdown-toggle {\n    white-space: nowrap;\n}\n.dropdown-toggle::after {\n    display: inline-block;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid;\n    border-right: 0.3em solid transparent;\n    border-bottom: 0;\n    border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n    margin-left: 0;\n}\n.dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    display: none;\n    float: left;\n    min-width: 10rem;\n    padding: 0.5rem 0;\n    margin: 0.125rem 0 0;\n    font-size: 1rem;\n    color: #212529;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 0.25rem;\n}\n.nav {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n}\n.nav-link {\n    display: block;\n    padding: 0.5rem 1rem;\n}\n.nav-link:hover,\n.nav-link:focus {\n    text-decoration: none;\n}\n.nav-tabs {\n    border-bottom: 1px solid #dee2e6;\n}\n.nav-tabs .nav-item {\n    margin-bottom: -1px;\n}\n.nav-tabs .nav-link {\n    border: 1px solid transparent;\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n}\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n    border-color: #e9ecef #e9ecef #dee2e6;\n}\n.nav-tabs .nav-link.active {\n    color: #495057;\n    background-color: #fff;\n    border-color: #dee2e6 #dee2e6 #fff;\n}\n.tab-content > .tab-pane {\n    display: none;\n}\n.tab-content > .active {\n    display: block;\n}\n.navbar {\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    padding: 0.5rem 1rem;\n}\n.navbar > .container-fluid {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n}\n.navbar-brand {\n    display: inline-block;\n    padding-top: 0.3125rem;\n    padding-bottom: 0.3125rem;\n    margin-right: 1rem;\n    font-size: 1.25rem;\n    line-height: inherit;\n    white-space: nowrap;\n}\n.navbar-brand:hover,\n.navbar-brand:focus {\n    text-decoration: none;\n}\n.navbar-nav {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n}\n.navbar-nav .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n}\n.navbar-collapse {\n    -ms-flex-preferred-size: 100%;\n    flex-basis: 100%;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.navbar-toggler {\n    padding: 0.25rem 0.75rem;\n    font-size: 1.25rem;\n    line-height: 1;\n    background-color: transparent;\n    border: 1px solid transparent;\n    border-radius: 0.25rem;\n}\n.navbar-toggler:hover,\n.navbar-toggler:focus {\n    text-decoration: none;\n}\n@media (max-width: 767.98px) {\n    .navbar-expand-md > .container-fluid {\n        padding-right: 0;\n        padding-left: 0;\n    }\n}\n@media (min-width: 768px) {\n    .navbar-expand-md {\n        -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n        -ms-flex-pack: start;\n        justify-content: flex-start;\n    }\n    .navbar-expand-md .navbar-nav {\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n    .navbar-expand-md .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n    .navbar-expand-md .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem;\n    }\n    .navbar-expand-md > .container-fluid {\n        -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    }\n    .navbar-expand-md .navbar-collapse {\n        display: -ms-flexbox !important;\n        display: flex !important;\n        -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    }\n    .navbar-expand-md .navbar-toggler {\n        display: none;\n    }\n}\n.navbar-dark .navbar-brand {\n    color: #fff;\n}\n.navbar-dark .navbar-brand:hover,\n.navbar-dark .navbar-brand:focus {\n    color: #fff;\n}\n.navbar-dark .navbar-nav .nav-link {\n    color: rgba(255, 255, 255, 0.5);\n}\n.navbar-dark .navbar-nav .nav-link:hover,\n.navbar-dark .navbar-nav .nav-link:focus {\n    color: rgba(255, 255, 255, 0.75);\n}\n.navbar-dark .navbar-toggler {\n    color: rgba(255, 255, 255, 0.5);\n    border-color: rgba(255, 255, 255, 0.1);\n}\n.close {\n    float: right;\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1;\n    color: #000;\n    text-shadow: 0 1px 0 #fff;\n    opacity: 0.5;\n}\n.close:hover {\n    color: #000;\n    text-decoration: none;\n}\nbutton.close {\n    padding: 0;\n    background-color: transparent;\n    border: 0;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n.popover {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1060;\n    display: block;\n    max-width: 276px;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    word-spacing: normal;\n    white-space: normal;\n    line-break: auto;\n    font-size: 0.875rem;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 0.3rem;\n}\n.popover .arrow {\n    position: absolute;\n    display: block;\n    width: 1rem;\n    height: 0.5rem;\n    margin: 0 0.3rem;\n}\n.popover .arrow::before,\n.popover .arrow::after {\n    position: absolute;\n    display: block;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid;\n}\n.bs-popover-top {\n    margin-bottom: 0.5rem;\n}\n.bs-popover-top > .arrow {\n    bottom: ~\"calc((0.5rem + 1px) * -1)\";\n}\n.bs-popover-top > .arrow::before {\n    bottom: 0;\n    border-width: 0.5rem 0.5rem 0;\n    border-top-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-top > .arrow::after {\n    bottom: 1px;\n    border-width: 0.5rem 0.5rem 0;\n    border-top-color: #fff;\n}\n.popover-header {\n    padding: 0.5rem 0.75rem;\n    margin-bottom: 0;\n    font-size: 1rem;\n    background-color: #f7f7f7;\n    border-bottom: 1px solid #ebebeb;\n    border-top-left-radius: ~\"calc(0.3rem - 1px)\";\n    border-top-right-radius: ~\"calc(0.3rem - 1px)\";\n}\n.popover-header:empty {\n    display: none;\n}\n.popover-body {\n    padding: 0.5rem 0.75rem;\n    color: #212529;\n}\n.d-none {\n    display: none !important;\n}\n.d-block {\n    display: block !important;\n}\n@media (min-width: 768px) {\n    .d-md-none {\n        display: none !important;\n    }\n    .d-md-block {\n        display: block !important;\n    }\n}\n.fixed-top {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1030;\n}\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n}\n.text-left {\n    text-align: left !important;\n}\n.text-center {\n    text-align: center !important;\n}\n@media print {\n    *,\n    *::before,\n    *::after {\n        text-shadow: none !important;\n        box-shadow: none !important;\n    }\n    a:not(.btn) {\n        text-decoration: underline;\n    }\n    tr,\n    img {\n        page-break-inside: avoid;\n    }\n    p,\n    h2,\n    h3 {\n        orphans: 3;\n        widows: 3;\n    }\n    h2,\n    h3 {\n        page-break-after: avoid;\n    }\n    body {\n        min-width: 992px !important;\n    }\n    .container {\n        min-width: 992px !important;\n    }\n    .navbar {\n        display: none;\n    }\n}\n.badge {\n    display: inline-block;\n    padding: 0.25em 0.4em;\n    font-size: 75%;\n    font-weight: 700;\n    line-height: 1;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: 0.25rem;\n    transition:\n        color 0.15s ease-in-out,\n        background-color 0.15s ease-in-out,\n        border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n}\n.badge-light {\n    color: #212529;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n}\n/*! CSS Used from: ../DynamicForms/DFStyle_Master.css?v=-2013962739 */\nhtml {\n    min-height: 100%;\n    position: relative;\n}\n.form-control {\n    color: #333333;\n}\n.form-control::-webkit-input-placeholder {\n    color: #999999;\n    opacity: 1;\n}\n.form-control::-moz-placeholder {\n    color: #999999;\n    opacity: 1;\n}\n.form-control:-ms-input-placeholder {\n    color: #999999;\n    opacity: 1;\n}\n.form-control::-ms-input-placeholder {\n    color: #999999;\n    opacity: 1;\n}\n.form-control::placeholder {\n    color: #999999;\n    opacity: 1;\n}\n.nav.navbar-nav {\n    margin: 0;\n}\nnav {\n    display: block;\n}\n@media (max-width: 767px) {\n    body {\n        padding-bottom: 0;\n    }\n}\n/*! CSS Used from: ../icons/style.css?v=7 */\n.icon:before {\n    font-family: accessgov !important;\n    speak: never;\n    font-style: normal;\n    font-weight: 400;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.icon-info:before {\n    content: \"\\62\";\n}\n.icon-search:before {\n    content: \"\\49\";\n}\n.icon-close:before {\n    content: \"\\74\";\n}\n.icon-user-solid:before {\n    content: \"\\e90d\";\n}\n","@font-face {\n    font-style: normal;\n    font-weight: 400;\n    src:\n        local(\"Open Sans Regular\"),\n        local(\"OpenSans-Regular\"),\n        url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFUZ0bbck.woff2) format(\"woff2\");\n    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* variables for easier Custom Less modification */\n@navbar-height: 70px;\n@small-font: 0.875rem;\n\nhtml {\n    position: relative;\n    min-height: 100vh;\n}\n\nbody {\n    padding-top: 70px;\n    background: #fff;\n    background-size: cover;\n    font-weight: normal;\n    font-family: \"Open Sans\", sans-serif;\n}\n\n.body-content {\n    width: 100%;\n    position: relative;\n}\n\na {\n    color: @link-color;\n}\n\na:hover {\n    cursor: pointer;\n    color: @link-color-hover;\n}\n\np {\n    clear: none;\n}\n\nh1 {\n    line-height: 1;\n    color: #333;\n}\n\nh1,\nh2,\nh3 {\n    margin-top: 10px;\n    font-weight: 500;\n}\n\nh1 {\n    font-size: 1.9rem;\n}\n\nh2 {\n    font-size: 1.65rem;\n}\n\nh3 {\n    font-size: 1.45rem;\n}\n\nh4 {\n    font-size: 1.3rem;\n}\n\nh5 {\n    font-size: 1.15rem;\n}\n\nh6 {\n    font-size: 1rem;\n}\n\n.pull-right {\n    float: right;\n}\n\n.loading {\n    margin: 15px auto;\n    display: block;\n    margin: 0 auto;\n    height: 100px;\n}\n\n.text-smaller {\n    font-size: @small-font;\n}\n\n.tile {\n    background: #ffffff;\n    border-radius: 8px;\n    padding: 15px;\n}\n\n[data-bind*=\"clickOrEnter\"],\n[data-bind^=\"clickOrEnter\"] {\n    cursor: pointer;\n}\n\n.dropdown-menu li,\n.returning_user li {\n    list-style-type: none;\n    list-style-position: initial;\n}\n\n.previous-question {\n    padding: 5px 10px;\n    border-top: 1px solid #ddd;\n    font-size: 13px;\n    cursor: pointer;\n\n    strong {\n        font-size: 15px;\n    }\n}\n\n.current-question {\n    border-top: 1px solid #ddd;\n}\n\n.answer.disabled {\n    opacity: 0.65;\n}\n\n.previous-question:hover,\n.previous-question:focus {\n    background: #f5f5f5;\n}\n\n.dropdown-menu {\n    border-radius: 0 0 6px 6px;\n}\n\n.dropdown.open {\n    .dropdown-menu {\n        opacity: 1;\n    }\n}\n\n.dropdown-toggle {\n    &.show + .dropdown-menu {\n        display: block;\n    }\n}\n\nlabel {\n    font-weight: 500;\n}\n\n// Specify id from public form to avoid\n// overlapping with form-control styles when form is accessed from admin\n#jsPageEditor {\n    .form-control,\n    .vs__dropdown-toggle,\n    .form-group .input-group .input-group-text {\n        font-weight: normal;\n        border-color: @primary-lightest;\n    }\n\n    .vs__dropdown-toggle .vs__open-indicator {\n        fill: @black;\n    }\n\n    .form-control:focus,\n    .vs--open .vs__dropdown-toggle {\n        border-width: 2px;\n        border-color: @active-black;\n        box-shadow: unset;\n\n        & ~ .vs__dropdown-menu {\n            --vs-border-width: 0;\n        }\n    }\n\n    .form-group {\n        .btn-group {\n            border-radius: 0.35rem;\n        }\n\n        &.text-form-group {\n            .input-group-append,\n            .input-group-prepend {\n                .input-group-text {\n                    &:focus {\n                        z-index: 0;\n                    }\n                }\n            }\n        }\n\n        &.has-custom-errors {\n            // Specify selectors to avoid inheriting styles if elements are nested\n            @width: 2px;\n            .border-mixin {\n                border-color: @custom-error-red;\n                border-width: 1px;\n                outline: unset;\n            }\n            .border-focus-mixin {\n                border-width: @width;\n                box-shadow: unset;\n            }\n            .invalid-border-mixin {\n                .border-mixin;\n                &:focus {\n                    .border-focus-mixin;\n                }\n            }\n\n            &.text-form-group {\n                & > div,\n                & > div > .datepicker-group {\n                    & > .form-control,\n                    & > .input-group-text {\n                        .invalid-border-mixin;\n                    }\n                    & > .input-group-append,\n                    & > .input-group-prepend {\n                        .input-group-text {\n                            .invalid-border-mixin;\n                            &:focus {\n                                outline: @width solid @custom-error-red;\n                                box-shadow: unset;\n                                border: unset;\n                                z-index: 0;\n                            }\n                        }\n                        &:not(.input-group-prepend) .input-group-text {\n                            border-left-width: 0;\n                        }\n                        &:not(.input-group-append) .input-group-text {\n                            border-right-width: 0;\n                        }\n                    }\n                }\n            }\n            &.dropdown-form-group {\n                & > div > div {\n                    & > select.form-control,\n                    & > .v-select .vs__dropdown-toggle {\n                        .border-mixin;\n                    }\n                    & > .v-select.vs--open .vs__dropdown-toggle {\n                        .border-focus-mixin;\n                    }\n                }\n            }\n            &.file-form-group {\n                & > div {\n                    & > .btn-file,\n                    & > .btn-group {\n                        .invalid-border-mixin;\n                        border-width: @width;\n                    }\n                    & > .btn-group {\n                        border-style: solid;\n                        a.btn {\n                            border-width: 0;\n                        }\n                        .input-group-append {\n                            border-top-width: 0;\n                            border-right-width: 0;\n                            border-bottom-width: 0;\n                        }\n                    }\n                }\n            }\n            // &.radio-form-group,\n            // &.checkbox-form-group {\n            //     & > fieldset:before {\n            //         content: \"\";\n            //         position: absolute;\n            //         top: 0;\n            //         left: 5px;\n            //         width: 2px;\n            //         height: 100%;\n            //         background: @custom-error-red;\n            //     }\n            // }\n        }\n    }\n}\n\n.form-check-label,\n.radio-inline,\n.checkbox label {\n    font-weight: normal;\n    margin-bottom: 0;\n}\n\n.page-loading {\n    position: fixed;\n    opacity: 1;\n    transition: all 0.4s ease-in;\n}\n\nhtml.no-js .page-loading {\n    display: none;\n}\n\n.page-loaded {\n    opacity: 0;\n    height: 0;\n    transition: none; /*ensure wheel doesn't fade out, rather disappears*/\n    z-index: -1;\n}\n\n.body-loading {\n    width: 100px;\n    height: 100px;\n    border-radius: 1.5ex;\n    padding: 0.2ex;\n    position: fixed;\n    left: calc(~\"50% - 50px\");\n    top: calc(~\"50% - 50px\");\n\n    .loading {\n        height: 100%;\n    }\n}\n\n.popover-header {\n    margin: 0;\n}\n\n.popper {\n    background: #ffffff;\n    max-width: 300px;\n    border: 1px solid #cccccc;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n    padding: 7.5px;\n}\n\n.form-check.answer {\n    position: static;\n}\n\n.v--modal-overlay {\n    z-index: 1002;\n}\n\n.modal-content {\n    border: none;\n    max-height: 100vh;\n    overflow-y: auto;\n}\n\n/* ------------------------\n NAVIGATION\n-/----------------------- */\n.skip-navigation-link:focus {\n    display: block;\n    top: 0;\n    width: auto !important;\n    height: auto !important;\n    z-index: 998999;\n    background: white;\n    clip: unset;\n}\n\n.navbar-dark {\n    background-color: @primary;\n    /*min-height: 60px;*/\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n\n.navbar-dark {\n    padding-left: 0;\n    padding-right: 0;\n\n    .navbar-nav .nav-link {\n        color: rgba(255, 255, 255, 0.9);\n        cursor: pointer;\n\n        &:hover,\n        &:focus {\n            color: rgba(255, 255, 255, 1);\n        }\n    }\n\n    // Scoped to .navbar-dark, not .navbar-nav, so the mobile .search-toggle (outside the\n    // list) also gets the outline. Color is a default-theme fallback; SiteIndex_Design.less\n    // recompiles it per tenant for WCAG 3:1.\n    .nav-link:focus,\n    .nav-link:focus-visible {\n        outline: 2px solid contrast(@primary, #000, #fff);\n        outline-offset: -2px;\n        box-shadow: none;\n    }\n\n    a {\n        white-space: nowrap;\n    }\n\n    a:hover,\n    a:focus {\n        text-decoration: none;\n    }\n}\n\n.icon-bar {\n    display: block;\n    background: #ffffff;\n    height: 1px;\n    width: 18px;\n    margin-top: 5px;\n}\n\n.navbar-fixed-top .navbar-collapse,\n.navbar-fixed-bottom .navbar-collapse {\n    max-height: none;\n    border: none;\n    box-shadow: none;\n    padding: 0;\n    width: 100%;\n}\n\n.navbar-dark .navbar-nav > li > a {\n    color: #fff;\n    font-size: 15px;\n    text-decoration: none;\n    display: inline-block;\n    letter-spacing: 0.5px;\n    /*text-transform: uppercase;*/\n}\n\n.navbar-dark .navbar-nav > li {\n    padding: 13px 7.5px;\n    button {\n        margin-bottom: 0;\n    }\n\n    ::-webkit-input-placeholder,\n    :-moz-placeholder,\n    ::-moz-placeholder,\n    :-ms-input-placeholder {\n        color: #fff !important;\n        opacity: 1 !important;\n    }\n}\n\nfieldset {\n    border: none;\n    padding: 0;\n    margin: 0;\n}\n\nlegend {\n    font-size: 1.2em;\n    font-weight: 500;\n}\n\n.navbar-dark .navbar-nav > .vr {\n    height: 50px;\n    width: 1px;\n    margin-top: 5px;\n    margin-left: 7px;\n    padding-left: 0;\n    padding-right: 7px;\n    border-left: 1px solid lighten(@primary, 7.5%);\n}\n\n.navbar-dark .navbar-nav > li:not(.active) > a:hover,\n.navbar-dark .navbar-nav > li > a:focus,\n.navbar-dark .navbar-nav > li:focus,\n.navbar-dark .navbar-nav > li.open > a:hover,\n.navbar-dark .navbar-nav > li.open > a:focus,\n.navbar-dark .navbar-nav > li.open > a:active,\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus,\n.dropdown-menu > li > a:active {\n    color: #fff;\n    background: @primary;\n    border-color: transparent;\n}\n\n.navbar-dark .navbar-nav > .open > a:hover,\n.navbar-dark .navbar-nav > .open > a:focus {\n    background: #27221a;\n}\n\n.navbar-dark .navbar-brand {\n    padding: 0;\n    img {\n        height: 50px;\n        display: inline;\n    }\n\n    .brand-letters {\n        display: inline;\n        margin-left: 4px;\n        img {\n            height: 25px;\n        }\n    }\n\n    /* cspell:ignore ccess */\n    .brand-letters-ccess,\n    .brand-letters-gov {\n        font-size: 40px;\n        letter-spacing: 6pt;\n        vertical-align: middle;\n        display: inline-block;\n        margin-top: -1px;\n    }\n\n    .brand-letters-ccess {\n        font-weight: bold;\n        color: #ccc;\n    }\n\n    .brand-letters-gov {\n        color: #fff;\n    }\n}\n\n.navbar-dark .navbar-right {\n    font-size: 1.1em;\n    letter-spacing: 0.4pt;\n    margin: 0;\n    margin-right: -15px;\n    margin-left: auto;\n}\n\n.form-control.search-control {\n    background: transparent url(\"../images/search.png\") no-repeat center left 7.5px;\n    background-size: 15px;\n    padding-left: 30px;\n}\n\n.navbar-dark .form-control.search-control:focus {\n    border-bottom-color: #fff;\n}\n\n.search-backdrop {\n    /*display: none;*/\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.9);\n    z-index: 10000;\n    .close {\n        position: fixed;\n        top: 30px;\n        right: 30px;\n        color: #fff;\n        font-size: 2em;\n        opacity: 1;\n        img {\n            height: 20px;\n        }\n    }\n\n    .search-form-wrapper {\n        width: 600px;\n        height: 100px;\n        max-width: 100%;\n        position: fixed;\n        top: 25vh;\n        left: calc(~\"50% - 300px\");\n        .form-group {\n            label {\n                font-size: 1.5em;\n                color: #aaa;\n                margin-bottom: 0;\n                -webkit-transition: all 0.25s;\n                transition: all 0.25s;\n            }\n\n            .form-control {\n                background: none;\n                height: 40px;\n                color: #ddd;\n                border: none;\n                padding: 10px;\n                border-bottom: 1px solid #aaa;\n                border-radius: 0;\n                box-shadow: none;\n            }\n\n            .form-control:focus {\n                border-color: @link-color;\n                border-bottom-width: 2px;\n            }\n        }\n    }\n}\n\n.nav-search-results {\n    position: relative;\n    height: auto;\n    max-height: calc(~\"75vh - 125px\");\n    min-height: 75px;\n    overflow-y: auto;\n    width: 600px;\n    max-width: 100%;\n    background: #fff;\n    margin-top: 0;\n    padding: 0;\n    border-radius: 4px;\n    box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.25);\n    overflow: auto;\n    .nav-search-results-inner {\n        padding: 15px;\n        position: relative;\n        height: auto;\n        width: 100%;\n        overflow-x: hidden;\n        text-align: left;\n    }\n\n    .nav-search-results-caption {\n        position: absolute;\n        top: 5px;\n        right: 10px;\n        display: inline-block;\n        color: #636363;\n        font-size: 12px;\n        /*font-weight: 600;*/\n    }\n\n    .result {\n        padding-top: 5px;\n        letter-spacing: normal;\n        /*font-size: 14px;*/\n        text-align: left;\n    }\n\n    .result:first-of-type {\n        padding-top: 10px;\n    }\n}\n\n.close {\n    opacity: 0.7;\n    font-size: 1.25em;\n}\n\n.dropdown-menu {\n    padding: 0;\n    padding-bottom: 8px;\n}\n\n.dropdown-menu > li > a {\n    display: block;\n    color: #fff;\n    font-size: 13px;\n    padding: 6px 18px;\n}\n\n.dropdown-menu .divider {\n    opacity: 0.3;\n    background-color: #000000;\n    margin: 0;\n    display: none;\n}\n\n.pane-size-toggle {\n    font-size: 32px;\n    margin-top: -10px;\n    -webkit-appearance: none;\n    padding: 0;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    float: right;\n}\n\n.toolbox_pane .pane-size-toggle {\n    margin-top: -14px;\n}\n\n.toggle-symbol {\n    font-size: 24px;\n    margin-top: -10px;\n}\n\n.toggle-smaller {\n    margin-left: 7px;\n}\n\n.toggle-larger {\n    margin-left: 0;\n}\n\n.pane-size-toggle.close:hover {\n    opacity: 1;\n}\n\n.df-public-nav {\n    .navbar {\n        min-height: 0;\n    }\n}\n\n.navbar-toggle.public_pages_toggle {\n    margin: 5px;\n    padding: 5px;\n}\n\n.navbar-collapse .list-group {\n    margin-bottom: 0;\n}\n\n.btn {\n    .icon {\n        line-height: 0;\n        vertical-align: inherit;\n    }\n    .icon-trash {\n        font-size: 1.1em;\n    }\n    .icon-undo,\n    .icon-redo {\n        font-size: 1.15em;\n    }\n}\n\n.btn-link {\n    color: @link-color;\n}\n\n.btn-link.icon {\n    &:active,\n    &:focus {\n        box-shadow: ~\"0 0 0 0.2rem rgb(0 123 255 / 25%)\";\n    }\n}\n\n.btn-group-vertical .btn {\n    margin-bottom: 0;\n}\n\n.fixed-top {\n    z-index: 1001;\n}\n\n.focus-mixin(@outline-color) {\n    outline: 2px solid @outline-color;\n    outline-offset: 2px;\n    box-shadow: unset;\n}\n\n.btn-primary {\n    background: @button-color;\n    color: #fff;\n    border-color: transparent;\n\n    &:hover {\n        background: @button-color-hover;\n        border-color: @button-color-hover;\n        color: #fff;\n    }\n\n    &:focus {\n        .focus-mixin(@button-color-hover);\n    }\n\n    &:active {\n        background: @button-color-hover !important;\n        color: #fff !important;\n        border-color: darken(@button-color, 10%);\n    }\n}\n\n.btn-outline-primary {\n    &:hover {\n        background: @button-color;\n        border-color: @button-color;\n    }\n\n    &:focus {\n        background: @button-color;\n        color: #fff;\n        .focus-mixin(@button-color);\n    }\n}\n\n.btn-outline-secondary {\n    &:focus {\n        background: #6c757d;\n        color: #ffffff;\n        .focus-mixin(#6c757d);\n    }\n}\n\n.btn-outline-danger {\n    &:focus {\n        background: #dc3545;\n        color: #ffffff;\n        .focus-mixin(#dc3545);\n    }\n}\n\n.btn-outline-success {\n    &:focus {\n        background: #28a745;\n        color: #ffffff;\n        .focus-mixin(#28a745);\n    }\n}\n\n.btn-bare {\n    &:focus {\n        .focus-mixin(@active-black);\n    }\n}\n\n.btn-block {\n    display: block;\n    width: 100%;\n}\n\n.btn.btn-xs {\n    padding: 2px 5px;\n    font-size: 0.75rem;\n    border-radius: 3px;\n    -webkit-transition: 0.1s all ease-in-out;\n    -moz-transition: 0.1s all ease-in-out;\n    -o-transition: 0.1s all ease-in-out;\n    transition: 0.1s all ease-in-out;\n}\n\n.notificationBarTop {\n    background: @notification-bar-top-color;\n    color: @text-color-primary;\n    text-align: center;\n    line-height: 2.5;\n    overflow: hidden;\n    /*margin-top: -15px;\n    margin-bottom: 15px;*/\n\n    a,\n    button:not(.close) {\n        color: @text-color-primary;\n        font-weight: bold;\n        border-bottom: 1px solid @text-color-primary;\n        border-radius: 0;\n        padding: 0;\n\n        &:hover {\n            color: @text-color-hover;\n        }\n    }\n\n    button:not(.close) {\n        text-decoration: none;\n    }\n\n    .close {\n        color: @button-color-text;\n        padding: 7px 10px;\n        opacity: 0.8;\n        font-size: 1.3em;\n\n        &:hover {\n            opacity: 1;\n        }\n    }\n\n    .close:not(:disabled):not(.disabled):hover,\n    .close:not(:disabled):not(.disabled):focus {\n        color: #fff;\n        opacity: 0.75;\n    }\n}\n\n.tab-content {\n    .result {\n        border-bottom: 1px solid #ddd;\n        padding: 15px;\n    }\n\n    .result:first-of-type {\n        border-top: 1px solid #ddd;\n    }\n}\n\n.form-group {\n    margin-bottom: 0.75rem;\n    label {\n        &.sr-only {\n            position: absolute;\n        }\n    }\n\n    legend {\n        font-size: 1em;\n        font-weight: 600;\n        border-bottom: none;\n        margin-bottom: 2px;\n    }\n\n    .radio-inline,\n    .checkbox-inline,\n    .checkbox label,\n    .radio label {\n        margin-left: 0;\n        margin-right: 10px;\n    }\n    /*label.focused {\n        color: @focus;\n    }*/\n}\n\n/*.radio-inline,\n.radio,\n.checkbox-inline,\n.checkbox {\n    font-size: 14px;\n}*/\n\n.loading {\n    margin: 15px auto;\n    display: block;\n    margin: 0 auto;\n    height: 100px;\n}\n\n.have_not_searched {\n    text-align: center;\n    height: 100%;\n    width: 100%;\n    /*padding-top: 15px;*/\n}\n\n.have_not_searched:before {\n    /*content: \"Use this search tool to find forms.\";*/\n    font-size: 1.2em;\n    vertical-align: middle;\n}\n\n#questionsDiv {\n    position: relative;\n    margin-bottom: 20px;\n\n    .radio {\n        margin-bottom: 7px;\n    }\n}\n.public-page-body {\n    .body-content {\n        padding: 0;\n    }\n}\n\n/* ------------------------\n AUTHENTICATED USER\n------------------------ */\n@my-forms-width: 375px;\n.index-container {\n    display: flex;\n    flex: 1;\n    flex-direction: column-reverse;\n}\n\n.index-content {\n    legend {\n        display: block;\n        width: 100%;\n        text-align: center;\n    }\n}\n\n.returning_user {\n    overflow: auto;\n    flex: 0 0 100%;\n    padding: 0px 15px 15px 15px;\n    background: #f9f9f9;\n    border-top: 1px solid #ccc;\n\n    .returning_user_header,\n    .returning_user_body {\n        visibility: visible;\n    }\n\n    .nav-tabs {\n        border-bottom-color: #bbbbbb;\n\n        li {\n            button {\n                background: none !important;\n            }\n        }\n    }\n\n    .badge {\n        margin-left: 5px;\n    }\n\n    .tab-content {\n        padding: 4px 0;\n        border: none;\n        border-top: none;\n    }\n\n    .returning_user_list_of_forms {\n        list-style: none;\n        padding: 0;\n\n        li {\n            position: relative;\n            display: table;\n            width: 100%;\n            padding: 0.5rem;\n            border-bottom: 1px solid #ccc;\n\n            .returning_user_actions {\n                float: right;\n                display: block;\n            }\n        }\n    }\n}\n\n#MyFormsHeading {\n    margin-top: 15px;\n    margin-bottom: 10px;\n}\n\n.submitted_timestamp {\n    font-size: 12px;\n    color: #6d6d6d;\n    float: left;\n    margin-top: 5px;\n}\n\n.my-forms-tag {\n    display: block;\n    clear: both;\n    padding: 2px 6px;\n    border-radius: 100px;\n    font-size: 80%;\n    margin-top: 5px;\n    margin-bottom: 2.5px;\n    float: left;\n    &.returned {\n        background: #ffebce;\n    }\n    &.in-progress {\n        background: #e0edff;\n    }\n    &.done {\n        background: #dbf2e4;\n    }\n    &.unavailable {\n        background: #ffe0e0;\n    }\n}\n\n.badge {\n    font-weight: 600;\n    display: inline-block;\n    padding: 0.25em 0.4em;\n    font-size: 75%;\n    font-weight: 700;\n    line-height: 1;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: 0.25rem;\n    transition:\n        color 0.15s ease-in-out,\n        background-color 0.15s ease-in-out,\n        border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n}\n\n.badge-primary {\n    color: #fff;\n    background-color: #007bff;\n}\n\n.badge-light {\n    border: 1px solid #dee2e6;\n}\n\ndiv .nav-tabs {\n    margin-right: 0;\n}\n\n.nav-tabs > li > .nav-link {\n    border: none;\n    border-bottom: 3px solid transparent;\n}\n\n.nav-tabs > li > .nav-link.active,\n.nav-tabs > li > .nav-link.active:hover,\n.nav-tabs > li > .nav-link.active:focus {\n    border-bottom: 3px solid @focus;\n    background-color: #fff;\n    border-radius: 0;\n    color: @focus !important;\n    border-bottom-color: @focus !important;\n}\n\n/*.nav-tabs > li.active > .nav-link.show {\n    border-bottom-color: transparent;\n}\n\n.nav-tabs > li.active > .nav-link,\n.nav-tabs > li.active > .nav-link:hover,\n.nav-tabs > li.active > .nav-link:focus {\n    border-bottom: 3px solid @focus;\n    background-color: #fff;\n    border-radius: 0;\n    color: @focus !important;\n    border-bottom-color: @focus !important;\n\n    .badge {\n        background-color: #333;\n    }\n}*/\n\n.nav-tabs > li {\n    margin-bottom: -1px;\n}\n\n.nav-tabs > li > .nav-link,\n.nav-tabs > li > .nav-link:hover {\n    color: inherit;\n    margin-right: 0;\n    background-color: transparent;\n}\n\n#myFormsDiv {\n    max-height: 495px;\n    overflow: auto;\n}\n\n#myFormsDiv ul {\n    padding-left: 20px;\n}\n\n#myFormsDiv li {\n    margin-bottom: 10px;\n}\n\n.navbar-dark .navbar-nav > li.login > a,\n.navbar-dark .navbar-nav > li.login.dropdown > a {\n    img {\n        height: 20px;\n        margin-right: 5px;\n    }\n}\n\n.navbar-dark .navbar-nav > li {\n}\n\n.navbar-dark .navbar-nav > li > a,\n.navbar-dark .navbar-nav > li > a:hover,\n.navbar-dark .navbar-nav > li > a:focus {\n    color: #fff;\n    background: transparent;\n}\n\n.navbar-dark .navbar-nav > li .dropdown-menu {\n    background-color: @primary;\n    border: 0;\n    left: auto;\n    right: 0;\n}\n\n.navbar-dark .navbar-nav > li .dropdown-menu > li > a,\n.navbar-dark .navbar-nav > li .dropdown-menu > li {\n    color: #fff;\n    /*text-transform: uppercase;*/\n}\n\n.nav .open > a,\n.nav .open > a:hover,\n.nav .open > a:focus {\n    border-color: transparent;\n}\n\n.help-block {\n    color: #717171;\n    font-size: 13px;\n}\n\n/*----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/\n\n/* ------------------------\n FOOTER\n------------------------ */\n\n#demo {\n    width: 600px;\n    padding-top: 5px;\n    margin-left: 10px;\n    float: left;\n}\n\n#demo a,\na.visited,\na.hover {\n    text-decoration: none;\n    border: none;\n}\n\n#footer {\n    background: @primary;\n    color: rgba(255, 255, 255, 0.9);\n    width: 100%;\n\n    ul {\n        padding: 24px 20px;\n        list-style-type: none;\n        text-align: center;\n        list-style: none outside none;\n        z-index: 11;\n        bottom: 0px;\n        margin: 0px auto;\n        flex: auto;\n        display: inline;\n\n        li {\n            margin: 0 5px;\n            display: inline-block;\n            color: #e2d5b4;\n\n            a {\n                background: none;\n                color: #fff;\n                letter-spacing: normal;\n                font-size: 12px;\n            }\n        }\n\n        li:first-of-type {\n            margin-left: 0;\n        }\n\n        li:last-of-type {\n            margin-right: 0;\n        }\n\n        li:hover {\n            background: none;\n            color: #e2d5b4;\n        }\n    }\n\n    > a {\n        margin-left: auto;\n        max-height: 48px;\n        border: none;\n    }\n}\n\n.mi-footer-logo {\n    height: 35px;\n    margin-top: -6px;\n}\n\n.accessgov-footer-logo {\n    height: 45px;\n    margin-top: -10px;\n}\n\n.visible-xs-inline-block {\n    display: none;\n}\n\n.my-forms-backdrop {\n    &:extend(.search-backdrop);\n    background: rgba(0, 0, 0, 0.5);\n    height: 100vh;\n    width: 100%;\n    z-index: 999;\n}\n\n.index-logo {\n    height: 150px;\n    margin: 10px auto;\n    max-width: 100%;\n}\n\n.public-page-body .tile {\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.public-page-body .body-content {\n    padding: 0 5px;\n}\n\n// .returning_user {\n//     margin: 0 -15px;\n// }\n\n@media (max-width: 767px) {\n    body {\n        padding-top: 60px;\n        background-image: none;\n        padding-bottom: 0 !important;\n    }\n\n    .body-content {\n        margin-top: 0;\n        padding-top: 0;\n    }\n\n    .transitions-after-load {\n        .body-content {\n            height: 100vh;\n        }\n    }\n\n    .nav .dropdown {\n        position: static;\n    }\n\n    .dropdown-menu {\n        position: static;\n        box-shadow: none;\n    }\n\n    .notificationBarTop {\n        /*margin-top: -10px;*/\n        margin-bottom: 0;\n    }\n    #footer {\n        position: static;\n        text-align: center;\n        height: auto;\n        /*margin-top: 25px;*/\n        padding: 15px 0;\n        display: block;\n\n        ul {\n            display: block;\n            width: 90%;\n\n            li {\n                display: block;\n                margin-left: 0;\n                margin-right: 0;\n\n                a:link,\n                a {\n                    /*background: @primary-light;*/\n                    float: none;\n                    display: block;\n                    margin: 0.5em 0px;\n                    padding: 1.2em 0 1.2em;\n                    height: auto;\n                    display: block;\n                    margin-bottom: 5px;\n                    /*color: #fff;*/\n                    padding-top: 10px;\n                    padding-bottom: 10px;\n                }\n\n                a:link:hover,\n                a:hover {\n                    background: #eee !important;\n                    text-decoration: underline;\n                    color: @primary;\n                }\n            }\n\n            li:hover a {\n                background: @primary-light;\n            }\n        }\n    }\n\n    #questionsDiv {\n        height: auto;\n        padding-bottom: 0;\n        position: relative;\n    }\n\n    .form-control {\n        max-width: none;\n    }\n\n    .visible-xs-inline-block {\n        display: inline-block !important;\n    }\n\n    .have_not_searched {\n        background-position: center center;\n        background-size: 150px;\n        padding-top: 30px;\n    }\n\n    /*.dfNavButton:not(.dfNavRemoveButton) {\n        display: block;\n        width: 100%;\n        margin-bottom: 5px;\n    }*/\n\n    .dropdown-toggle {\n        width: 100%;\n    }\n\n    .pane-size-toggle {\n        -webkit-transform: rotate(90deg);\n        transform: rotate(90deg);\n        margin-top: -8px !important;\n        margin-right: 0 !important;\n    }\n\n    .navbar-dark {\n        padding: 13px 5px;\n\n        a.search-toggle,\n        a.search-toggle:hover,\n        a.search-toggle:focus {\n            float: right;\n            color: #ffffff;\n            opacity: 0.8;\n            padding: 0 10px;\n\n            .icon {\n                display: block;\n                margin-top: 2px;\n            }\n        }\n\n        .navbar-brand {\n            width: min-content;\n            margin: 0 auto;\n\n            img {\n                height: 33px;\n            }\n\n            .brand-letters {\n                margin-left: 3px;\n\n                img {\n                    height: 15px;\n                }\n            }\n        }\n\n        .navbar-toggler,\n        .navbar-toggler:focus,\n        .navbar-toggler:hover {\n            background: @primary;\n            border: none;\n            box-shadow: none;\n            padding: 0.25rem 0.75rem 0.5rem 0.75rem;\n            /*.navbar-toggler-icon {\n                width: 20px;\n                height: 20px;\n            }*/\n        }\n    }\n\n    .search-backdrop {\n        padding: 5px 15px;\n        height: 150vh;\n\n        .close {\n            font-size: 1.4em;\n            top: 15px;\n            right: 15px;\n            img {\n                height: 15px;\n            }\n        }\n\n        .search-form-wrapper {\n            position: static;\n            margin-top: 40px;\n            width: 100%;\n            .form-control {\n                label {\n                }\n            }\n        }\n    }\n\n    .navbar-dark .navbar-nav > .vr {\n        display: none;\n    }\n\n    .navbar-dark .form-group.search-group .search-control {\n        width: 100% !important;\n    }\n\n    .navbar-dark .navbar-left {\n        margin-left: 0;\n        margin-right: -15px;\n    }\n\n    .navbar-dark .navbar-nav > li {\n        padding: 0 7px;\n    }\n\n    .navbar-dark {\n        .icon-search {\n            font-size: 1.4em;\n        }\n    }\n\n    #collapse2 {\n        padding: 8px;\n        overflow-x: hidden;\n    }\n\n    .nav-search-results {\n        position: relative;\n        width: calc(~\"100% - 30px\");\n        z-index: 10000;\n        max-height: calc(~\"100vh - 150px\");\n        /*background: #fff;\n        margin-top: 0;\n        padding: 0;\n        border: 1px solid #ddd;\n        box-shadow: 0 2px 6px 1px rgba(0,0,0,.25);\n        overflow: auto;*/\n        .nav-search-results-inner {\n            padding: 15px;\n            position: relative;\n            height: auto;\n            width: 100%;\n        }\n\n        .nav-search-results-caption {\n            position: absolute;\n            top: 5px;\n            right: 10px;\n            display: inline-block;\n            color: #717171;\n            font-size: 11px;\n        }\n\n        .result {\n            padding-top: 5px;\n            letter-spacing: normal;\n            font-size: 13px;\n        }\n\n        .result:first-of-type {\n            padding-top: 10px;\n        }\n    }\n}\n\n@media (min-width: 768px) {\n    body,\n    label,\n    .btn,\n    .form-control {\n        font-size: 15px;\n    }\n    .navbar-dark {\n        height: @navbar-height;\n        .navbar-brand {\n            pointer-events: none;\n        }\n    }\n    .public-page-body .body-content {\n        padding: 0;\n    }\n\n    .index-content {\n        padding: 15px;\n    }\n\n    .returning_user {\n        margin: 0;\n    }\n    .mi-footer-logo {\n        float: right;\n    }\n\n    .lead {\n        font-size: 16px;\n    }\n    .accessgov-footer-logo {\n        float: left;\n    }\n\n    .my-forms-backdrop {\n        display: none;\n    }\n\n    #collapse2 {\n        margin-right: 10px;\n    }\n\n    .navbar-inverse .navbar-nav > li .dropdown-menu {\n        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);\n    }\n}\n\n@media (max-width: 991px) {\n    .img-responsive {\n        /* account for large homepage images to be responsive on mobile devices */\n        max-width: 100%;\n        height: auto !important;\n    }\n}\n\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n    .lead {\n        font-size: 17px;\n    }\n    .index-container {\n        flex-direction: row;\n        min-height: calc(~\"100vh\" - @navbar-height);\n\n        .index-content {\n            flex: 1;\n        }\n\n        .returning_user {\n            flex: 0 0 @my-forms-width;\n            border-top: none;\n            border-right: 1px solid #ccc;\n            overflow: auto;\n        }\n    }\n    .body-content {\n        min-height: calc(~\"100vh\" - @navbar-height);\n    }\n}\n\n@media (min-width: 1200px) {\n    .have_not_searched {\n        background-position: center 40%;\n    }\n}\n\n@media print {\n    .no_print,\n    #footer,\n    .btn {\n        display: none !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
